{
  "level": "it01",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:it01",
    "objects": "AREAS.E3:it01.e3",
    "mesh": "TREES.E3:it01.e3"
  },
  "spawn_point": {
    "position": [
      -3756.729161836981,
      -3210.218363142155,
      1029.2000122070312
    ],
    "facing_rad": 0.0,
    "look_point": [
      -3756.729161836981,
      -3110.218363142155,
      1029.2000122070312
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -4115.0,
      -3645.0,
      1005.2000122070312
    ],
    "bbox_max": [
      -3409.81591796875,
      -2775.0,
      1170.0
    ],
    "vertex_count": 337,
    "vertices": [
      [
        -3768.69677734375,
        -3405.0,
        1110.0
      ],
      [
        -3780.0,
        -3405.0,
        1110.0
      ],
      [
        -3780.0,
        -3645.0,
        1110.0
      ],
      [
        -3768.69677734375,
        -3645.0,
        1110.0
      ],
      [
        -3780.0,
        -3405.0,
        1110.0
      ],
      [
        -3768.69677734375,
        -3405.0,
        1110.0
      ],
      [
        -3780.0,
        -3383.909912109375,
        1128.98095703125
      ],
      [
        -3738.802490234375,
        -3240.800048828125,
        1059.800048828125
      ],
      [
        -3738.802490234375,
        -3203.99755859375,
        1059.800048828125
      ],
      [
        -3776.00048828125,
        -3099.800048828125,
        1059.800048828125
      ],
      [
        -3776.00048828125,
        -3089.800048828125,
        1052.5999755859375
      ],
      [
        -3776.00048828125,
        -3089.800048828125,
        1049.855224609375
      ],
      [
        -3776.00048828125,
        -3089.800048828125,
        1052.5999755859375
      ],
      [
        -3746.4248046875,
        -3240.800048828125,
        1072.5999755859375
      ],
      [
        -3746.4248046875,
        -3196.375244140625,
        1072.5999755859375
      ],
      [
        -3779.60009765625,
        -3237.769287109375,
        1059.800048828125
      ],
      [
        -3779.60009765625,
        -3237.769287109375,
        1072.5999755859375
      ],
      [
        -3746.4248046875,
        -3196.375244140625,
        1072.5999755859375
      ],
      [
        -3738.802490234375,
        -3203.99755859375,
        1059.800048828125
      ],
      [
        -3738.802490234375,
        -3240.800048828125,
        1059.800048828125
      ],
      [
        -3746.4248046875,
        -3240.800048828125,
        1072.5999755859375
      ],
      [
        -3795.494384765625,
        -2775.0,
        1155.0
      ],
      [
        -3925.0,
        -2775.0,
        1155.0
      ],
      [
        -3925.0,
        -3253.733642578125,
        1155.0
      ],
      [
        -3795.494384765625,
        -3253.7333984375,
        1155.0
      ],
      [
        -3821.650390625,
        -3143.137451171875,
        1072.311279296875
      ],
      [
        -3834.150390625,
        -3139.813232421875,
        1072.2176513671875
      ],
      [
        -3809.150390625,
        -3139.762939453125,
        1072.4051513671875
      ],
      [
        -3821.650390625,
        -3143.137451171875,
        1072.311279296875
      ],
      [
        -3821.650390625,
        -3143.148193359375,
        1060.1761474609375
      ],
      [
        -3834.150390625,
        -3139.830078125,
        1060.29296875
      ],
      [
        -3809.150390625,
        -3139.767333984375,
        1060.059326171875
      ],
      [
        -3821.650390625,
        -3143.148193359375,
        1060.1761474609375
      ],
      [
        -3843.30126953125,
        -3130.7021484375,
        1060.37841796875
      ],
      [
        -3834.150390625,
        -3139.830078125,
        1060.29296875
      ],
      [
        -3844.846435546875,
        -3116.402099609375,
        1060.3929443359375
      ],
      [
        -3844.846435546875,
        -3123.135009765625,
        1060.3929443359375
      ],
      [
        -3843.519287109375,
        -3109.647705078125,
        1060.3804931640625
      ],
      [
        -3844.846435546875,
        -3116.402099609375,
        1060.3929443359375
      ],
      [
        -3844.846435546875,
        -3123.135009765625,
        1060.3929443359375
      ],
      [
        -3843.519287109375,
        -3129.889404296875,
        1060.3804931640625
      ],
      [
        -3843.519287109375,
        -3129.889404296875,
        1060.3804931640625
      ],
      [
        -3843.30126953125,
        -3130.7021484375,
        1060.37841796875
      ],
      [
        -3893.500244140625,
        -3131.767822265625,
        1022.0
      ],
      [
        -3867.0,
        -3131.767822265625,
        1022.0
      ],
      [
        -3893.500244140625,
        -3131.767822265625,
        1022.0
      ],
      [
        -3898.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      [
        -3898.50048828125,
        -3163.69677734375,
        1056.786865234375
      ],
      [
        -3898.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      [
        -3901.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      [
        -3898.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      [
        -3858.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      [
        -3858.50048828125,
        -3163.69677734375,
        1056.786865234375
      ],
      [
        -3858.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      [
        -3858.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3861.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      [
        -3858.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      [
        -3861.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      [
        -3858.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      [
        -3818.50048828125,
        -3163.69677734375,
        1056.786865234375
      ],
      [
        -3818.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      [
        -3821.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      [
        -3818.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      [
        -3858.50048828125,
        -3181.7685546875,
        1076.492919921875
      ],
      [
        -3858.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3898.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3898.50048828125,
        -3181.7685546875,
        1076.492919921875
      ],
      [
        -3901.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3898.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3858.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3861.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3818.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3818.50048828125,
        -3181.7685546875,
        1076.492919921875
      ],
      [
        -3821.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3818.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3898.50048828125,
        -3163.704833984375,
        1056.786865234375
      ],
      [
        -3898.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3858.50048828125,
        -3163.704833984375,
        1056.786865234375
      ],
      [
        -3858.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3858.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3861.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3858.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3818.50048828125,
        -3163.704833984375,
        1056.786865234375
      ],
      [
        -3922.50048828125,
        -3129.7841796875,
        1012.5
      ],
      [
        -3922.50048828125,
        -3164.10009765625,
        1012.5
      ],
      [
        -3920.000244140625,
        -3164.10009765625,
        1019.7999877929688
      ],
      [
        -3920.000244140625,
        -3164.10009765625,
        1019.7999877929688
      ],
      [
        -3920.00048828125,
        -3164.10009765625,
        1036.786865234375
      ],
      [
        -3920.000244140625,
        -3145.371337890625,
        1036.786865234375
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1019.7999877929688
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      [
        -3922.50048828125,
        -3181.77001953125,
        1012.5
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1019.7999877929688
      ],
      [
        -3901.50048828125,
        -3181.77001953125,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3181.77001953125,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      [
        -3920.00048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      [
        -3920.000244140625,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3920.00048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      [
        -3858.50048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      [
        -3858.50048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      [
        -3898.50048828125,
        -3181.77001953125,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1039.786865234375
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1076.49462890625
      ],
      [
        -3898.50048828125,
        -3181.77001953125,
        1059.786865234375
      ],
      [
        -3898.50048828125,
        -3181.77001953125,
        1056.786865234375
      ],
      [
        -3901.50048828125,
        -3181.77001953125,
        1059.786865234375
      ],
      [
        -3898.50048828125,
        -3181.77001953125,
        1059.786865234375
      ],
      [
        -3901.50048828125,
        -3184.77001953125,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3184.77001953125,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3184.7685546875,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3181.7685546875,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3184.77001953125,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3184.77001953125,
        1036.786865234375
      ],
      [
        -3920.00048828125,
        -3184.77001953125,
        1019.7999877929688
      ],
      [
        -3920.00048828125,
        -3184.77001953125,
        1039.786865234375
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1039.786865234375
      ],
      [
        -3920.030029296875,
        -3184.77001953125,
        1019.71337890625
      ],
      [
        -3925.0,
        -3182.2685546875,
        1012.5
      ],
      [
        -3925.0,
        -3184.77001953125,
        1019.71337890625
      ],
      [
        -3920.030029296875,
        -3184.77001953125,
        1019.71337890625
      ],
      [
        -3920.00048828125,
        -3184.77001953125,
        1019.7999877929688
      ],
      [
        -3818.50048828125,
        -3184.7685546875,
        1039.786865234375
      ],
      [
        -3818.50048828125,
        -3181.7685546875,
        1039.786865234375
      ],
      [
        -3858.50048828125,
        -3181.7685546875,
        1039.786865234375
      ],
      [
        -3858.50048828125,
        -3184.7685546875,
        1039.786865234375
      ],
      [
        -3901.50048828125,
        -3184.77001953125,
        1059.786865234375
      ],
      [
        -3898.50048828125,
        -3184.77001953125,
        1059.786865234375
      ],
      [
        -3898.50048828125,
        -3184.77001953125,
        1059.786865234375
      ],
      [
        -3898.50048828125,
        -3184.77001953125,
        1056.786865234375
      ],
      [
        -3898.50048828125,
        -3184.7685546875,
        1059.786865234375
      ],
      [
        -3898.50048828125,
        -3181.7685546875,
        1059.786865234375
      ],
      [
        -3920.00048828125,
        -3184.77001953125,
        1059.786865234375
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1059.786865234375
      ],
      [
        -3818.50048828125,
        -3184.7685546875,
        1059.786865234375
      ],
      [
        -3818.50048828125,
        -3181.7685546875,
        1059.786865234375
      ],
      [
        -3858.50048828125,
        -3181.7685546875,
        1059.786865234375
      ],
      [
        -3858.50048828125,
        -3184.7685546875,
        1059.786865234375
      ],
      [
        -3920.00048828125,
        -3184.77001953125,
        1079.767333984375
      ],
      [
        -3797.0,
        -3405.0,
        1110.0
      ],
      [
        -3797.0,
        -3645.0,
        1110.0
      ],
      [
        -3797.0,
        -3355.0,
        1155.0
      ],
      [
        -3795.494384765625,
        -3355.0,
        1155.0
      ],
      [
        -3797.0,
        -3253.7333984375,
        1155.0
      ],
      [
        -3795.494384765625,
        -3355.0,
        1155.0
      ],
      [
        -3797.0,
        -3355.0,
        1155.0
      ],
      [
        -3797.0,
        -3405.0,
        1110.0
      ],
      [
        -3797.0,
        -3224.7685546875,
        1005.2000122070312
      ],
      [
        -3797.0,
        -3224.7685546875,
        1069.540283203125
      ],
      [
        -3797.0,
        -3224.7685546875,
        1069.540283203125
      ],
      [
        -3797.0,
        -3224.7685546875,
        1079.800048828125
      ],
      [
        -3797.0,
        -3224.7685546875,
        1079.800048828125
      ],
      [
        -3797.0,
        -3184.800048828125,
        1079.800048828125
      ],
      [
        -3797.0,
        -3224.7685546875,
        1059.796875
      ],
      [
        -3797.0,
        -3215.7685546875,
        1059.796875
      ],
      [
        -3797.0,
        -3215.7685546875,
        1059.796875
      ],
      [
        -3797.0,
        -3215.7685546875,
        1056.605712890625
      ],
      [
        -3850.0,
        -3405.0,
        1110.0
      ],
      [
        -3850.0,
        -3645.0,
        1110.0
      ],
      [
        -3850.0,
        -3355.0,
        1155.0
      ],
      [
        -3850.0,
        -3253.733642578125,
        1155.0
      ],
      [
        -3850.0,
        -3355.0,
        1155.0
      ],
      [
        -3850.0,
        -3405.0,
        1110.0
      ],
      [
        -3850.0,
        -3224.7685546875,
        1005.2000122070312
      ],
      [
        -3850.0,
        -3224.7685546875,
        1037.5540771484375
      ],
      [
        -3850.0,
        -3224.7685546875,
        1037.5540771484375
      ],
      [
        -3850.0,
        -3224.7685546875,
        1079.800048828125
      ],
      [
        -3850.0,
        -3224.7685546875,
        1079.800048828125
      ],
      [
        -3850.0,
        -3184.800048828125,
        1079.800048828125
      ],
      [
        -3840.929931640625,
        -3215.7685546875,
        1056.6207275390625
      ],
      [
        -3898.5,
        -3405.0,
        1110.0
      ],
      [
        -3898.5,
        -3645.0,
        1110.0
      ],
      [
        -3898.5,
        -3355.0,
        1155.0
      ],
      [
        -3898.5,
        -3253.733642578125,
        1155.0
      ],
      [
        -3898.5,
        -3355.0,
        1155.0
      ],
      [
        -3898.5,
        -3405.0,
        1110.0
      ],
      [
        -3898.5,
        -3224.7685546875,
        1079.800048828125
      ],
      [
        -3898.5,
        -3224.7685546875,
        1016.1558837890625
      ],
      [
        -3898.5,
        -3224.7685546875,
        1079.800048828125
      ],
      [
        -3898.5,
        -3184.800048828125,
        1079.800048828125
      ],
      [
        -3925.0,
        -3405.0,
        1110.0
      ],
      [
        -3925.0,
        -3645.0,
        1110.0
      ],
      [
        -3925.0,
        -3355.0,
        1155.0
      ],
      [
        -3925.0,
        -3355.0,
        1155.0
      ],
      [
        -3925.0,
        -3405.0,
        1110.0
      ],
      [
        -3925.0,
        -3184.800048828125,
        1019.7999877929688
      ],
      [
        -4115.0,
        -3184.800048828125,
        1155.0
      ],
      [
        -3925.0,
        -3184.800048828125,
        1155.0
      ],
      [
        -3544.122314453125,
        -3251.63916015625,
        1040.7083740234375
      ],
      [
        -3544.122314453125,
        -3251.63916015625,
        1040.7083740234375
      ],
      [
        -3545.3388671875,
        -3246.626220703125,
        1037.0
      ],
      [
        -3561.915771484375,
        -3153.577392578125,
        1057.0
      ],
      [
        -3561.915771484375,
        -3153.577392578125,
        1037.0
      ],
      [
        -3584.54736328125,
        -3160.063720703125,
        1037.0
      ],
      [
        -3592.554443359375,
        -3169.221923828125,
        1044.549560546875
      ],
      [
        -3508.000244140625,
        -3288.2685546875,
        1059.800048828125
      ],
      [
        -3508.000244140625,
        -3288.2685546875,
        1081.84033203125
      ],
      [
        -3508.000244140625,
        -3288.2685546875,
        1081.84033203125
      ],
      [
        -3508.000244140625,
        -3288.2685546875,
        1059.800048828125
      ],
      [
        -3466.0,
        -3135.0,
        1070.0
      ],
      [
        -3451.0,
        -3170.0,
        1070.0
      ],
      [
        -3501.0,
        -3135.0,
        1070.0
      ],
      [
        -3466.0,
        -3135.0,
        1070.0
      ],
      [
        -3620.671630859375,
        -3223.60009765625,
        1075.0
      ],
      [
        -3708.000244140625,
        -3275.2685546875,
        1059.800048828125
      ],
      [
        -3708.000244140625,
        -3275.2685546875,
        1081.84033203125
      ],
      [
        -3708.000244140625,
        -3275.2685546875,
        1081.84033203125
      ],
      [
        -3708.000244140625,
        -3275.2685546875,
        1059.800048828125
      ],
      [
        -3667.606689453125,
        -3155.313720703125,
        1072.0
      ],
      [
        -3667.606689453125,
        -3155.313720703125,
        1070.0
      ],
      [
        -3672.0,
        -3144.0,
        1070.0
      ],
      [
        -3672.0,
        -3144.0,
        1072.0
      ],
      [
        -3642.0,
        -3144.0,
        1072.0
      ],
      [
        -3642.0,
        -3144.0,
        1070.0
      ],
      [
        -3646.393310546875,
        -3155.313720703125,
        1070.0
      ],
      [
        -3646.393310546875,
        -3155.313720703125,
        1072.0
      ],
      [
        -3646.393310546875,
        -3155.313720703125,
        1072.0
      ],
      [
        -3646.393310546875,
        -3155.313720703125,
        1070.0
      ],
      [
        -3657.0,
        -3160.0,
        1070.0
      ],
      [
        -3657.0,
        -3160.0,
        1072.0
      ],
      [
        -3657.0,
        -3160.0,
        1072.0
      ],
      [
        -3657.0,
        -3160.0,
        1070.0
      ],
      [
        -3667.606689453125,
        -3155.313720703125,
        1070.0
      ],
      [
        -3667.606689453125,
        -3155.313720703125,
        1072.0
      ],
      [
        -3680.0,
        -3144.0,
        1072.0
      ],
      [
        -3680.0,
        -3144.0,
        1070.0
      ],
      [
        -3684.393310546875,
        -3155.313720703125,
        1070.0
      ],
      [
        -3684.393310546875,
        -3155.313720703125,
        1072.0
      ],
      [
        -3705.606689453125,
        -3155.313720703125,
        1072.0
      ],
      [
        -3705.606689453125,
        -3155.313720703125,
        1070.0
      ],
      [
        -3710.0,
        -3144.0,
        1070.0
      ],
      [
        -3710.0,
        -3144.0,
        1072.0
      ],
      [
        -3695.0,
        -3160.0,
        1072.0
      ],
      [
        -3695.0,
        -3160.0,
        1070.0
      ],
      [
        -3705.606689453125,
        -3155.313720703125,
        1070.0
      ],
      [
        -3705.606689453125,
        -3155.313720703125,
        1072.0
      ],
      [
        -3684.393310546875,
        -3155.313720703125,
        1072.0
      ],
      [
        -3684.393310546875,
        -3155.313720703125,
        1070.0
      ],
      [
        -3695.0,
        -3160.0,
        1070.0
      ],
      [
        -3695.0,
        -3160.0,
        1072.0
      ],
      [
        -3672.0,
        -3144.0,
        1072.0
      ],
      [
        -3672.0,
        -3144.0,
        1070.0
      ],
      [
        -3680.0,
        -3144.0,
        1070.0
      ],
      [
        -3680.0,
        -3144.0,
        1072.0
      ],
      [
        -3672.0,
        -3181.725341796875,
        1070.0
      ],
      [
        -3672.0,
        -3181.725341796875,
        1072.0
      ],
      [
        -3668.72119140625,
        -3200.238037109375,
        1070.0
      ],
      [
        -3668.72119140625,
        -3210.238037109375,
        1070.0
      ],
      [
        -3668.72119140625,
        -3200.238037109375,
        1070.0
      ],
      [
        -3683.27880859375,
        -3200.238037109375,
        1070.0
      ],
      [
        -3683.27880859375,
        -3210.238037109375,
        1070.0
      ],
      [
        -3683.27880859375,
        -3200.238037109375,
        1070.0
      ],
      [
        -3616.43115234375,
        -3375.831787109375,
        1155.0
      ],
      [
        -3739.99658203125,
        -3361.962158203125,
        1155.0
      ],
      [
        -3733.513427734375,
        -3103.375,
        1155.0
      ],
      [
        -3617.02099609375,
        -3103.375,
        1155.0
      ],
      [
        -3522.741943359375,
        -3094.375,
        1155.0
      ],
      [
        -3439.212158203125,
        -3094.375,
        1155.0
      ],
      [
        -3533.759033203125,
        -3093.999755859375,
        1170.0
      ],
      [
        -3522.741943359375,
        -3094.375,
        1155.0
      ],
      [
        -3528.74169921875,
        -3103.374755859375,
        1155.0
      ],
      [
        -3439.212158203125,
        -3094.375,
        1155.0
      ],
      [
        -3429.173095703125,
        -3093.999755859375,
        1170.0
      ],
      [
        -3435.35498046875,
        -3103.374755859375,
        1155.0
      ],
      [
        -3777.625,
        -3289.9775390625,
        1155.0
      ],
      [
        -3777.625,
        -3180.16162109375,
        1155.0
      ],
      [
        -3584.98046875,
        -3187.733154296875,
        1155.0
      ],
      [
        -3777.625,
        -3180.16162109375,
        1155.0
      ],
      [
        -3733.513427734375,
        -3103.375,
        1155.0
      ],
      [
        -3739.99658203125,
        -3361.962158203125,
        1155.0
      ],
      [
        -3777.625,
        -3289.9775390625,
        1155.0
      ],
      [
        -3617.02099609375,
        -3103.375,
        1155.0
      ],
      [
        -3600.16796875,
        -3172.545654296875,
        1155.0
      ],
      [
        -3600.16796875,
        -3172.545654296875,
        1155.0
      ],
      [
        -3591.91796875,
        -3188.858154296875,
        1155.0
      ],
      [
        -3591.91796875,
        -3188.858154296875,
        1155.0
      ],
      [
        -3584.98046875,
        -3187.733154296875,
        1155.0
      ],
      [
        -3520.8994140625,
        -3367.14697265625,
        1155.0
      ],
      [
        -3616.43115234375,
        -3375.831787109375,
        1155.0
      ],
      [
        -3409.81591796875,
        -3162.966064453125,
        1155.0
      ],
      [
        -3416.05908203125,
        -3256.61328125,
        1155.0
      ],
      [
        -3416.05908203125,
        -3256.61328125,
        1155.0
      ],
      [
        -3455.7890625,
        -3329.45166015625,
        1155.0
      ],
      [
        -3455.7890625,
        -3329.45166015625,
        1155.0
      ],
      [
        -3520.8994140625,
        -3367.14697265625,
        1155.0
      ],
      [
        -3409.81591796875,
        -3162.966064453125,
        1155.0
      ],
      [
        -3616.3515625,
        -3368.307861328125,
        1143.0228271484375
      ],
      [
        -3738.35400390625,
        -3359.5634765625,
        1150.892822265625
      ],
      [
        -3522.267578125,
        -3362.842041015625,
        1147.942138671875
      ],
      [
        -3616.3515625,
        -3368.307861328125,
        1143.0228271484375
      ],
      [
        -3499.91796875,
        -3354.999755859375,
        1155.0
      ],
      [
        -3522.267578125,
        -3362.842041015625,
        1147.942138671875
      ],
      [
        -3738.35400390625,
        -3359.5634765625,
        1150.892822265625
      ],
      [
        -3743.635986328125,
        -3355.0,
        1155.0
      ],
      [
        -3568.378662109375,
        -3213.533203125,
        1110.0
      ],
      [
        -3507.68994140625,
        -3122.5,
        1110.0
      ],
      [
        -3749.5,
        -3283.070068359375,
        1110.0
      ],
      [
        -3749.5,
        -3187.6650390625,
        1110.0
      ],
      [
        -3717.23486328125,
        -3131.5,
        1110.0
      ],
      [
        -3634.314208984375,
        -3131.5,
        1110.0
      ],
      [
        -3749.5,
        -3187.6650390625,
        1110.0
      ],
      [
        -3717.23486328125,
        -3131.5,
        1110.0
      ],
      [
        -3721.9990234375,
        -3335.6806640625,
        1110.0
      ],
      [
        -3749.5,
        -3283.070068359375,
        1110.0
      ],
      [
        -3696.42041015625,
        -3362.569091796875,
        1148.1878662109375
      ],
      [
        -3721.9990234375,
        -3335.6806640625,
        1110.0
      ],
      [
        -3654.835693359375,
        -3343.219482421875,
        1110.0
      ],
      [
        -3634.314208984375,
        -3131.5,
        1110.0
      ],
      [
        -3629.128662109375,
        -3152.783203125,
        1110.0
      ],
      [
        -3629.128662109375,
        -3152.783203125,
        1110.0
      ],
      [
        -3596.128662109375,
        -3218.033203125,
        1110.0
      ],
      [
        -3596.128662109375,
        -3218.033203125,
        1110.0
      ],
      [
        -3568.378662109375,
        -3213.533203125,
        1110.0
      ],
      [
        -3438.327880859375,
        -3167.835693359375,
        1110.0
      ],
      [
        -3443.71044921875,
        -3248.5732421875,
        1110.0
      ],
      [
        -3529.622802734375,
        -3339.698974609375,
        1110.0
      ],
      [
        -3616.132568359375,
        -3347.563720703125,
        1110.0
      ],
      [
        -3443.71044921875,
        -3248.5732421875,
        1110.0
      ],
      [
        -3476.704345703125,
        -3309.06201171875,
        1110.0
      ],
      [
        -3507.68994140625,
        -3122.5,
        1110.0
      ],
      [
        -3457.757568359375,
        -3122.5,
        1110.0
      ],
      [
        -3457.757568359375,
        -3122.5,
        1110.0
      ],
      [
        -3438.327880859375,
        -3167.835693359375,
        1110.0
      ],
      [
        -3616.132568359375,
        -3347.563720703125,
        1110.0
      ],
      [
        -3476.704345703125,
        -3309.06201171875,
        1110.0
      ],
      [
        -3529.622802734375,
        -3339.698974609375,
        1110.0
      ],
      [
        -3639.892333984375,
        -3131.5,
        1110.0
      ],
      [
        -3654.835693359375,
        -3343.219482421875,
        1110.0
      ],
      [
        -3633.056640625,
        -3333.08544921875,
        1090.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3780.0,
      "bbox_min": [
        -4115.0,
        -3645.0,
        978.0
      ],
      "bbox_max": [
        -3738.802490234375,
        -2775.0,
        1155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -3780.0,
        -3645.0,
        1046.5
      ],
      "bbox_max": [
        -3738.802490234375,
        -3089.800048828125,
        1128.98095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6689647436141968,
        -0.7432941198348999
      ],
      "plane_d": 3102.88134765625,
      "bbox_min": [
        -3780.0,
        -3405.0,
        1110.0
      ],
      "bbox_max": [
        -3768.69677734375,
        -3383.909912109375,
        1128.98095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.800048828125,
      "bbox_min": [
        -3780.0,
        -3240.800048828125,
        1046.5
      ],
      "bbox_max": [
        -3738.802490234375,
        -3089.800048828125,
        1079.800048828125
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3776.00048828125,
      "bbox_min": [
        -3779.60009765625,
        -3139.7685546875,
        1046.5
      ],
      "bbox_max": [
        -3760.0,
        -3089.800048828125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5843086838722229,
        -0.8115315437316895
      ],
      "plane_d": -951.178955078125,
      "bbox_min": [
        -3779.60009765625,
        -3099.800048828125,
        1049.855224609375
      ],
      "bbox_max": [
        -3776.00048828125,
        -3089.800048828125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3089.800048828125,
      "bbox_min": [
        -3779.60009765625,
        -3089.800048828125,
        1049.855224609375
      ],
      "bbox_max": [
        -3776.00048828125,
        -3089.800048828125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5843086838722229,
        -0.8115315437316895
      ],
      "plane_d": -951.178955078125,
      "bbox_min": [
        -3776.00048828125,
        -3099.800048828125,
        1046.5
      ],
      "bbox_max": [
        -3760.0,
        -3089.800048828125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3089.800048828125,
      "bbox_min": [
        -3776.00048828125,
        -3099.800048828125,
        1046.5
      ],
      "bbox_max": [
        -3760.0,
        -3089.800048828125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3099.800048828125,
      "bbox_min": [
        -3776.00048828125,
        -3099.800048828125,
        1056.0999755859375
      ],
      "bbox_max": [
        -3764.00048828125,
        -3099.800048828125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1072.5999755859375,
      "bbox_min": [
        -3780.0,
        -3240.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3738.802490234375,
        -3099.800048828125,
        1079.800048828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1079.7999267578125,
      "bbox_min": [
        -3780.0,
        -3237.800048828125,
        1072.5999755859375
      ],
      "bbox_max": [
        -3760.0,
        -3178.2001953125,
        1079.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2081708163022995,
        0.20849911868572235,
        -0.9556112885475159
      ],
      "plane_d": 917.3447875976562,
      "bbox_min": [
        -3780.0,
        -3237.800048828125,
        1072.5999755859375
      ],
      "bbox_max": [
        -3760.0,
        -3178.2001953125,
        1079.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3760.0,
      "bbox_min": [
        -3780.0,
        -3237.800048828125,
        1072.5999755859375
      ],
      "bbox_max": [
        -3760.0,
        -3178.2001953125,
        1079.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0007629509782418609,
        0.48450347781181335,
        -0.8747890591621399
      ],
      "plane_d": 2509.892822265625,
      "bbox_min": [
        -3780.0,
        -3237.800048828125,
        1072.5999755859375
      ],
      "bbox_max": [
        -3760.0,
        -3178.2001953125,
        1079.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.737165093421936,
        -0.6757127642631531
      ],
      "plane_d": -1618.088623046875,
      "bbox_min": [
        -3780.0,
        -3184.800048828125,
        1072.5999755859375
      ],
      "bbox_max": [
        -3760.0,
        -3178.2001953125,
        1079.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3758.0,
      "bbox_min": [
        -3780.0,
        -3240.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3738.802490234375,
        -3099.800048828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3779.60009765625,
      "bbox_min": [
        -3780.0,
        -3237.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3758.0,
        -3099.800048828125,
        1072.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.737052321434021,
        -0.6758357286453247
      ],
      "plane_d": -1617.598388671875,
      "bbox_min": [
        -3780.0,
        -3237.769287109375,
        1059.800048828125
      ],
      "bbox_max": [
        -3779.60009765625,
        -3109.800048828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3109.800048828125,
      "bbox_min": [
        -3780.0,
        -3109.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3779.60009765625,
        -3109.800048828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0015747050056234002,
        0.9999987483024597,
        -0.0
      ],
      "plane_d": 3243.716796875,
      "bbox_min": [
        -3780.0,
        -3237.769287109375,
        1059.800048828125
      ],
      "bbox_max": [
        -3779.60009765625,
        -3237.7685546875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3760.0,
      "bbox_min": [
        -3779.60009765625,
        -3237.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3758.0,
        -3099.800048828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3184.800048828125,
      "bbox_min": [
        -3760.0,
        -3204.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3758.0,
        -3184.800048828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3204.800048828125,
      "bbox_min": [
        -3760.0,
        -3204.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3758.0,
        -3204.800048828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0015747050056234002,
        0.9999987483024597,
        -0.0
      ],
      "plane_d": 3243.716796875,
      "bbox_min": [
        -3779.60009765625,
        -3237.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3760.0,
        -3099.800048828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3099.800048828125,
      "bbox_min": [
        -3779.60009765625,
        -3099.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3760.0,
        -3099.800048828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -4909.30126953125,
      "bbox_min": [
        -3758.0,
        -3240.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3738.802490234375,
        -3184.800048828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3240.800048828125,
      "bbox_min": [
        -3758.0,
        -3240.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3738.802490234375,
        -3240.800048828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3925.0,
      "bbox_min": [
        -4115.0,
        -3645.0,
        994.0
      ],
      "bbox_max": [
        -3780.0,
        -2775.0,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.737154483795166,
        -0.6757242679595947
      ],
      "plane_d": -1618.042724609375,
      "bbox_min": [
        -3925.00048828125,
        -3645.0,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -2775.0,
        1155.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1155.0,
      "bbox_min": [
        -3925.00048828125,
        -3253.733642578125,
        1022.0
      ],
      "bbox_max": [
        -3780.0,
        -2775.0,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3072.300048828125,
      "bbox_min": [
        -3925.00048828125,
        -3184.7685546875,
        1022.0
      ],
      "bbox_max": [
        -3780.0,
        -3072.300048828125,
        1099.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7367177605628967,
        -0.6762003898620605
      ],
      "plane_d": -1616.152099609375,
      "bbox_min": [
        -3901.50048828125,
        -3184.7685546875,
        1022.0
      ],
      "bbox_max": [
        -3780.00048828125,
        -3108.943359375,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7375450134277344,
        -0.6752980351448059
      ],
      "plane_d": -1617.855712890625,
      "bbox_min": [
        -3901.50048828125,
        -3184.7685546875,
        1022.0
      ],
      "bbox_max": [
        -3780.00048828125,
        -3108.943359375,
        1079.786865234375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.007501009851694107,
        0.0,
        -0.9999719262123108
      ],
      "plane_d": 1100.947509765625,
      "bbox_min": [
        -3846.650390625,
        -3144.7685546875,
        1047.4737548828125
      ],
      "bbox_max": [
        -3780.00048828125,
        -3108.943359375,
        1078.7237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25056278705596924,
        -0.9351131319999695,
        0.2505628168582916
      ],
      "plane_d": -4165.43359375,
      "bbox_min": [
        -3834.150390625,
        -3143.137451171875,
        1072.2176513671875
      ],
      "bbox_max": [
        -3809.150390625,
        -3138.5185546875,
        1078.7237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25056275725364685,
        -0.9351130723953247,
        0.25056275725364685
      ],
      "plane_d": -2250.306884765625,
      "bbox_min": [
        -3821.650390625,
        -3143.137451171875,
        1072.311279296875
      ],
      "bbox_max": [
        -3809.150390625,
        -3138.5185546875,
        1078.7237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03997047245502472,
        -0.9992008805274963,
        0.0
      ],
      "plane_d": -3258.371826171875,
      "bbox_min": [
        -3846.650390625,
        -3144.7685546875,
        1047.4737548828125
      ],
      "bbox_max": [
        -3780.00048828125,
        -3108.943359375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.009344073943793774,
        -0.0,
        0.9999563097953796
      ],
      "plane_d": -1024.4200439453125,
      "bbox_min": [
        -3846.650390625,
        -3144.7685546875,
        1047.4737548828125
      ],
      "bbox_max": [
        -3780.00048828125,
        -3108.943359375,
        1072.4051513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6947321891784668,
        0.5086063742637634,
        0.5085928440093994
      ],
      "plane_d": 3723.2099609375,
      "bbox_min": [
        -3844.846435546875,
        -3143.148193359375,
        1047.4737548828125
      ],
      "bbox_max": [
        -3809.150390625,
        -3108.943359375,
        1060.3929443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2505628168582916,
        -0.9351131319999695,
        -0.2505628168582916
      ],
      "plane_d": -3631.121826171875,
      "bbox_min": [
        -3844.846435546875,
        -3143.148193359375,
        1053.7237548828125
      ],
      "bbox_max": [
        -3809.150390625,
        -3108.943359375,
        1060.3929443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2505628168582916,
        -0.9351130723953247,
        -0.25056275725364685
      ],
      "plane_d": -1715.99462890625,
      "bbox_min": [
        -3844.846435546875,
        -3143.148193359375,
        1053.7237548828125
      ],
      "bbox_max": [
        -3809.150390625,
        -3108.943359375,
        1060.3929443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6947435736656189,
        0.6947460174560547,
        0.18617023527622223
      ],
      "plane_d": 4647.74072265625,
      "bbox_min": [
        -3844.846435546875,
        -3139.830078125,
        1055.3984375
      ],
      "bbox_max": [
        -3834.150390625,
        -3108.943359375,
        1060.3929443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9553250670433044,
        0.0,
        0.29555708169937134
      ],
      "plane_d": 3359.671630859375,
      "bbox_min": [
        -3844.846435546875,
        -3130.7021484375,
        1055.3984375
      ],
      "bbox_max": [
        -3843.30126953125,
        -3108.943359375,
        1060.3929443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.963616132736206,
        -0.1890050768852234,
        0.18900004029273987
      ],
      "plane_d": 2915.52587890625,
      "bbox_min": [
        -3844.846435546875,
        -3130.7021484375,
        1055.3984375
      ],
      "bbox_max": [
        -3843.30126953125,
        -3108.943359375,
        1060.3929443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9636161923408508,
        0.1890050619840622,
        0.18900002539157867
      ],
      "plane_d": 4094.830322265625,
      "bbox_min": [
        -3844.846435546875,
        -3130.7021484375,
        1055.3984375
      ],
      "bbox_max": [
        -3843.30126953125,
        -3123.135009765625,
        1060.3929443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9636160731315613,
        0.2581813633441925,
        0.06918453425168991
      ],
      "plane_d": 4438.39404296875,
      "bbox_min": [
        -3843.519287109375,
        -3130.7021484375,
        1059.9737548828125
      ],
      "bbox_max": [
        -3843.30126953125,
        -3129.889404296875,
        1060.3804931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25056275725364685,
        -0.9351130723953247,
        0.25056275725364685
      ],
      "plane_d": -2250.306884765625,
      "bbox_min": [
        -3846.650390625,
        -3144.7685546875,
        1060.059326171875
      ],
      "bbox_max": [
        -3809.150390625,
        -3109.647705078125,
        1072.4051513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2505628168582916,
        -0.9351130723953247,
        -0.25056275725364685
      ],
      "plane_d": -1715.99462890625,
      "bbox_min": [
        -3846.650390625,
        -3144.7685546875,
        1060.059326171875
      ],
      "bbox_max": [
        -3809.150390625,
        -3109.647705078125,
        1072.311279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25056278705596924,
        -0.9351131319999695,
        0.2505628168582916
      ],
      "plane_d": -4165.43359375,
      "bbox_min": [
        -3846.650390625,
        -3144.7685546875,
        1060.1761474609375
      ],
      "bbox_max": [
        -3821.650390625,
        -3109.647705078125,
        1072.311279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2505628168582916,
        -0.9351131319999695,
        -0.2505628168582916
      ],
      "plane_d": -3631.121826171875,
      "bbox_min": [
        -3846.650390625,
        -3144.7685546875,
        1060.1761474609375
      ],
      "bbox_max": [
        -3821.650390625,
        -3109.647705078125,
        1066.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6947435736656189,
        0.6947460174560547,
        0.18617023527622223
      ],
      "plane_d": 4647.74072265625,
      "bbox_min": [
        -3846.650390625,
        -3141.419189453125,
        1060.29296875
      ],
      "bbox_max": [
        -3834.150390625,
        -3109.647705078125,
        1066.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9636160731315613,
        0.2581813633441925,
        0.06918453425168991
      ],
      "plane_d": 4438.39404296875,
      "bbox_min": [
        -3846.650390625,
        -3132.2685546875,
        1060.37841796875
      ],
      "bbox_max": [
        -3843.30126953125,
        -3109.647705078125,
        1066.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.963616132736206,
        -0.1890050768852234,
        0.18900004029273987
      ],
      "plane_d": 2915.52587890625,
      "bbox_min": [
        -3846.650390625,
        -3129.889404296875,
        1060.3804931640625
      ],
      "bbox_max": [
        -3843.519287109375,
        -3109.647705078125,
        1066.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9636161923408508,
        0.1890050619840622,
        0.18900002539157867
      ],
      "plane_d": 4094.830322265625,
      "bbox_min": [
        -3846.650390625,
        -3129.889404296875,
        1060.3804931640625
      ],
      "bbox_max": [
        -3843.519287109375,
        -3116.402099609375,
        1066.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9553250670433044,
        0.0,
        0.29555708169937134
      ],
      "plane_d": 3359.671630859375,
      "bbox_min": [
        -3846.650390625,
        -3123.135009765625,
        1060.3929443359375
      ],
      "bbox_max": [
        -3844.846435546875,
        -3116.402099609375,
        1066.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1063.0,
      "bbox_min": [
        -3901.50048828125,
        -3184.7685546875,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3129.314453125,
        1079.786865234375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1022.0,
      "bbox_min": [
        -3901.50048828125,
        -3166.454833984375,
        1022.0
      ],
      "bbox_max": [
        -3818.50048828125,
        -3129.314453125,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3893.500244140625,
      "bbox_min": [
        -3901.50048828125,
        -3166.454833984375,
        1022.0
      ],
      "bbox_max": [
        -3818.50048828125,
        -3129.314453125,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3898.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3166.454833984375,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3145.076904296875,
        1059.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1039.786865234375,
      "bbox_min": [
        -3901.50048828125,
        -3166.454833984375,
        1039.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3147.7783203125,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.786865234375,
      "bbox_min": [
        -3901.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3166.2734375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3858.50048828125,
      "bbox_min": [
        -3861.50048828125,
        -3166.454833984375,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3145.076904296875,
        1059.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1039.786865234375,
      "bbox_min": [
        -3861.50048828125,
        -3166.454833984375,
        1039.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3147.7783203125,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.786865234375,
      "bbox_min": [
        -3861.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3166.2734375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3818.50048828125,
      "bbox_min": [
        -3821.50048828125,
        -3166.454833984375,
        1056.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3163.4990234375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.786865234375,
      "bbox_min": [
        -3821.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3166.2734375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1076.0,
      "bbox_min": [
        -3901.50048828125,
        -3184.7685546875,
        1063.0
      ],
      "bbox_max": [
        -3786.0,
        -3166.854248046875,
        1079.786865234375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3858.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3184.7685546875,
        1076.492919921875
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3898.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3184.7685546875,
        1076.492919921875
      ],
      "bbox_max": [
        -3858.50048828125,
        -3181.7685546875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3184.7685546875,
      "bbox_min": [
        -3901.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      "bbox_max": [
        -3898.50048828125,
        -3184.7685546875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3184.7685546875,
      "bbox_min": [
        -3861.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      "bbox_max": [
        -3858.50048828125,
        -3184.7685546875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3818.50048828125,
      "bbox_min": [
        -3821.50048828125,
        -3184.7685546875,
        1076.492919921875
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3184.7685546875,
      "bbox_min": [
        -3821.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      "bbox_max": [
        -3818.50048828125,
        -3184.7685546875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3852.500244140625,
      "bbox_min": [
        -3893.500244140625,
        -3181.316650390625,
        1063.0
      ],
      "bbox_max": [
        -3812.500244140625,
        -3166.854248046875,
        1076.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        9.590487024979666e-05,
        8.781073847785592e-05
      ],
      "plane_d": 3893.710693359375,
      "bbox_min": [
        -3893.500244140625,
        -3181.316650390625,
        1063.0
      ],
      "bbox_max": [
        -3893.5,
        -3166.854248046875,
        1076.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3812.500244140625,
      "bbox_min": [
        -3812.500244140625,
        -3181.316650390625,
        1063.0
      ],
      "bbox_max": [
        -3812.500244140625,
        -3166.854248046875,
        1076.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1022.0,
      "bbox_min": [
        -3901.50048828125,
        -3166.454833984375,
        1022.0
      ],
      "bbox_max": [
        -3818.50048828125,
        -3131.767822265625,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.738097071647644,
        -0.6746945977210999
      ],
      "plane_d": -1622.046875,
      "bbox_min": [
        -3901.50048828125,
        -3166.454833984375,
        1022.0
      ],
      "bbox_max": [
        -3818.50048828125,
        -3131.767822265625,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3893.500244140625,
      "bbox_min": [
        -3893.500244140625,
        -3143.699951171875,
        1022.0
      ],
      "bbox_max": [
        -3893.5,
        -3131.767822265625,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3898.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3166.454833984375,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3145.33984375,
        1059.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1039.786865234375,
      "bbox_min": [
        -3901.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3858.50048828125,
      "bbox_min": [
        -3861.50048828125,
        -3166.454833984375,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3145.33984375,
        1059.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1039.786865234375,
      "bbox_min": [
        -3861.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3818.50048828125,
      "bbox_min": [
        -3818.50048828125,
        -3166.454833984375,
        1056.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3163.69677734375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9460593461990356,
        -0.323993444442749
      ],
      "plane_d": -2630.56787109375,
      "bbox_min": [
        -3922.50048828125,
        -3129.800048828125,
        1012.5
      ],
      "bbox_max": [
        -3780.0,
        -3127.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        -0.323993444442749
      ],
      "plane_d": 4038.96142578125,
      "bbox_min": [
        -3922.50048828125,
        -3129.800048828125,
        1012.5
      ],
      "bbox_max": [
        -3920.0,
        -3127.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3184.77001953125,
      "bbox_min": [
        -3925.0,
        -3645.0,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3129.7841796875,
        1155.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.4082273244857788,
        -0.40826764702796936,
        0.8164974451065063
      ],
      "plane_d": -3707.34619140625,
      "bbox_min": [
        -3880.00048828125,
        -3154.2685546875,
        1023.4426879882812
      ],
      "bbox_max": [
        -3872.10986328125,
        -3146.3779296875,
        1033.275634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40822869539260864,
        -0.4082396328449249,
        0.816510796546936
      ],
      "plane_d": -3711.205810546875,
      "bbox_min": [
        -3880.00048828125,
        -3154.2685546875,
        1028.25439453125
      ],
      "bbox_max": [
        -3873.68798828125,
        -3147.9560546875,
        1033.275634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40825092792510986,
        -0.40825092792510986,
        0.8164939880371094
      ],
      "plane_d": -539.3541259765625,
      "bbox_min": [
        -3887.89111328125,
        -3154.2685546875,
        1023.4426879882812
      ],
      "bbox_max": [
        -3880.00048828125,
        -3146.3779296875,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4082440137863159,
        -0.40820634365081787,
        0.816519558429718
      ],
      "plane_d": -543.1951904296875,
      "bbox_min": [
        -3886.31298828125,
        -3154.2685546875,
        1028.25439453125
      ],
      "bbox_max": [
        -3880.00048828125,
        -3147.9560546875,
        1033.275634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4082252085208893,
        0.4082781672477722,
        0.8164931535720825
      ],
      "plane_d": 2036.09912109375,
      "bbox_min": [
        -3887.89111328125,
        -3162.158935546875,
        1023.4426879882812
      ],
      "bbox_max": [
        -3880.00048828125,
        -3154.2685546875,
        1029.7197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        -0.323993444442749
      ],
      "plane_d": 4038.96142578125,
      "bbox_min": [
        -3922.50048828125,
        -3164.10009765625,
        1012.5
      ],
      "bbox_max": [
        -3920.0,
        -3129.7841796875,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3922.50048828125,
        -3181.77001953125,
        1012.5
      ],
      "bbox_max": [
        -3920.000244140625,
        -3164.10009765625,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        -0.323993444442749
      ],
      "plane_d": 4038.96142578125,
      "bbox_min": [
        -3922.50048828125,
        -3181.77001953125,
        1012.5
      ],
      "bbox_max": [
        -3920.000244140625,
        -3164.10009765625,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1039.786865234375,
      "bbox_min": [
        -3920.00048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      "bbox_max": [
        -3780.00048828125,
        -3145.371337890625,
        1076.49462890625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3167.7685546875,
      "bbox_min": [
        -3920.00048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      "bbox_max": [
        -3780.00048828125,
        -3145.371337890625,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3898.50048828125,
      "bbox_min": [
        -3920.00048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3145.371337890625,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3920.00048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3920.000244140625,
        -3145.371337890625,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3858.50048828125,
      "bbox_min": [
        -3858.50048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3145.37158203125,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3898.50048828125,
      "bbox_min": [
        -3920.00048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3920.00048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      "bbox_max": [
        -3920.00048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3858.50048828125,
      "bbox_min": [
        -3858.50048828125,
        -3181.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3920.00048828125,
        -3181.77001953125,
        1039.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3148.121337890625,
        1076.49462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3898.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3181.77001953125,
        1056.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3163.704833984375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.786865234375,
      "bbox_min": [
        -3901.50048828125,
        -3181.77001953125,
        1059.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.786865234375,
      "bbox_min": [
        -3861.50048828125,
        -3181.7685546875,
        1059.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3818.50048828125,
      "bbox_min": [
        -3821.50048828125,
        -3181.7685546875,
        1056.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3163.704833984375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.786865234375,
      "bbox_min": [
        -3821.50048828125,
        -3181.7685546875,
        1059.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1039.786865234375,
      "bbox_min": [
        -3925.0,
        -3184.77001953125,
        1005.2037963867188
      ],
      "bbox_max": [
        -3780.00048828125,
        -3181.7685546875,
        1079.767333984375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3898.50048828125,
      "bbox_min": [
        -3925.0,
        -3184.77001953125,
        1005.2037963867188
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1039.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3925.0,
        -3184.77001953125,
        1012.5
      ],
      "bbox_max": [
        -3920.00048828125,
        -3181.77001953125,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9448028206825256,
        -0.32763931155204773
      ],
      "plane_d": -2674.881591796875,
      "bbox_min": [
        -3925.0,
        -3184.77001953125,
        1012.5
      ],
      "bbox_max": [
        -3920.00048828125,
        -3181.77001953125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        -0.323993444442749
      ],
      "plane_d": 4038.96142578125,
      "bbox_min": [
        -3922.50048828125,
        -3184.77001953125,
        1012.5
      ],
      "bbox_max": [
        -3920.00048828125,
        -3181.77001953125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3818.50048828125,
      "bbox_min": [
        -3858.50048828125,
        -3184.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3858.50048828125,
      "bbox_min": [
        -3858.50048828125,
        -3184.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3858.50048828125,
        -3181.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.786865234375,
      "bbox_min": [
        -3920.00048828125,
        -3184.77001953125,
        1039.786865234375
      ],
      "bbox_max": [
        -3780.00048828125,
        -3181.7685546875,
        1079.767333984375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3898.50048828125,
      "bbox_min": [
        -3920.00048828125,
        -3184.77001953125,
        1039.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1059.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3920.00048828125,
        -3184.77001953125,
        1039.786865234375
      ],
      "bbox_max": [
        -3920.00048828125,
        -3181.77001953125,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3818.50048828125,
      "bbox_min": [
        -3858.50048828125,
        -3184.7685546875,
        1039.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3858.50048828125,
      "bbox_min": [
        -3858.50048828125,
        -3184.7685546875,
        1039.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3181.7685546875,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3858.50048828125,
      "bbox_min": [
        -3920.00048828125,
        -3184.77001953125,
        1059.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1079.767333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3920.00048828125,
        -3184.77001953125,
        1059.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3181.7685546875,
        1079.767333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3898.50048828125,
      "bbox_min": [
        -3898.50048828125,
        -3184.7685546875,
        1059.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3181.7685546875,
        1079.7655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3818.50048828125,
      "bbox_min": [
        -3818.50048828125,
        -3184.7685546875,
        1059.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1079.7655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3898.5,
      "bbox_min": [
        -3925.0,
        -3645.0,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3184.77001953125,
        1155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3850.0,
      "bbox_min": [
        -3898.5,
        -3645.0,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3184.800048828125,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -3797.0,
        -3645.0,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3184.800048828125,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1155.0,
      "bbox_min": [
        -3797.0,
        -3405.0,
        1110.0
      ],
      "bbox_max": [
        -3780.0,
        -3253.7333984375,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6689647436141968,
        -0.7432941198348999
      ],
      "plane_d": 3102.88134765625,
      "bbox_min": [
        -3797.0,
        -3405.0,
        1110.0
      ],
      "bbox_max": [
        -3780.0,
        -3355.0,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3224.7685546875,
      "bbox_min": [
        -3797.0,
        -3237.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3184.800048828125,
        1079.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3237.7685546875,
      "bbox_min": [
        -3792.0,
        -3237.7685546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3780.0,
        -3226.7685546875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1072.5999755859375,
      "bbox_min": [
        -3792.0,
        -3237.7685546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3780.0,
        -3226.7685546875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.800048828125,
      "bbox_min": [
        -3792.0,
        -3237.7685546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3780.0,
        -3226.7685546875,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1079.800048828125,
      "bbox_min": [
        -3797.0,
        -3224.7685546875,
        1056.5999755859375
      ],
      "bbox_max": [
        -3780.0,
        -3184.800048828125,
        1079.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.00018833574722521007,
        0.0,
        1.0
      ],
      "plane_d": -1060.511962890625,
      "bbox_min": [
        -3797.0,
        -3224.7685546875,
        1056.5999755859375
      ],
      "bbox_max": [
        -3780.0,
        -3215.7685546875,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3215.7685546875,
      "bbox_min": [
        -3797.0,
        -3215.7685546875,
        1056.5999755859375
      ],
      "bbox_max": [
        -3780.0,
        -3215.7685546875,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -3850.00048828125,
        -3645.0,
        1005.2000122070312
      ],
      "bbox_max": [
        -3797.0,
        -3184.800048828125,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1155.0,
      "bbox_min": [
        -3850.0,
        -3405.0,
        1110.0
      ],
      "bbox_max": [
        -3797.0,
        -3253.7333984375,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6689647436141968,
        -0.7432941198348999
      ],
      "plane_d": 3102.88134765625,
      "bbox_min": [
        -3850.0,
        -3405.0,
        1110.0
      ],
      "bbox_max": [
        -3797.0,
        -3355.0,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3224.7685546875,
      "bbox_min": [
        -3850.00048828125,
        -3224.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3797.0,
        -3184.800048828125,
        1079.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1079.800048828125,
      "bbox_min": [
        -3850.00048828125,
        -3224.7685546875,
        1041.286865234375
      ],
      "bbox_max": [
        -3797.0,
        -3184.800048828125,
        1079.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32955682277679443,
        0.0,
        0.9441357254981995
      ],
      "plane_d": 268.2113037109375,
      "bbox_min": [
        -3850.00048828125,
        -3224.7685546875,
        1041.286865234375
      ],
      "bbox_max": [
        -3797.0,
        -3200.7685546875,
        1059.796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3215.7685546875,
      "bbox_min": [
        -3850.00048828125,
        -3215.7685546875,
        1056.6207275390625
      ],
      "bbox_max": [
        -3840.929931640625,
        -3215.7685546875,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.00018833574722521007,
        0.0,
        1.0
      ],
      "plane_d": -1060.511962890625,
      "bbox_min": [
        -3850.00048828125,
        -3224.7685546875,
        1056.605712890625
      ],
      "bbox_max": [
        -3797.0,
        -3215.7685546875,
        1059.796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3215.7685546875,
      "bbox_min": [
        -3850.00048828125,
        -3215.7685546875,
        1056.605712890625
      ],
      "bbox_max": [
        -3797.0,
        -3215.7685546875,
        1059.796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -3898.5,
        -3645.0,
        1005.2000122070312
      ],
      "bbox_max": [
        -3850.0,
        -3184.800048828125,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1155.0,
      "bbox_min": [
        -3898.5,
        -3405.0,
        1110.0
      ],
      "bbox_max": [
        -3850.0,
        -3253.733642578125,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6689647436141968,
        -0.7432941198348999
      ],
      "plane_d": 3102.88134765625,
      "bbox_min": [
        -3898.5,
        -3405.0,
        1110.0
      ],
      "bbox_max": [
        -3850.0,
        -3355.0,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3224.7685546875,
      "bbox_min": [
        -3898.5,
        -3224.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3850.0,
        -3184.800048828125,
        1079.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1079.800048828125,
      "bbox_min": [
        -3898.5,
        -3224.7685546875,
        1059.786865234375
      ],
      "bbox_max": [
        -3850.0,
        -3184.800048828125,
        1079.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.786865234375,
      "bbox_min": [
        -3867.00048828125,
        -3224.7685546875,
        1059.786865234375
      ],
      "bbox_max": [
        -3850.00048828125,
        -3200.7685546875,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -3925.0,
        -3645.0,
        1016.1558837890625
      ],
      "bbox_max": [
        -3898.5,
        -3184.77001953125,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1155.0,
      "bbox_min": [
        -3925.0,
        -3405.0,
        1110.0
      ],
      "bbox_max": [
        -3898.5,
        -3253.733642578125,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6689647436141968,
        -0.7432941198348999
      ],
      "plane_d": 3102.88134765625,
      "bbox_min": [
        -3925.0,
        -3405.0,
        1110.0
      ],
      "bbox_max": [
        -3898.5,
        -3355.0,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3925.0,
        -3224.7685546875,
        1016.1558837890625
      ],
      "bbox_max": [
        -3898.5,
        -3184.77001953125,
        1079.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9448028206825256,
        -0.32763931155204773
      ],
      "plane_d": -2674.881591796875,
      "bbox_min": [
        -3925.0,
        -3184.800048828125,
        1019.71337890625
      ],
      "bbox_max": [
        -3920.00048828125,
        -3184.77001953125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        -0.323993444442749
      ],
      "plane_d": 4038.96142578125,
      "bbox_min": [
        -3920.030029296875,
        -3184.800048828125,
        1019.71337890625
      ],
      "bbox_max": [
        -3920.00048828125,
        -3184.77001953125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3224.7685546875,
      "bbox_min": [
        -3920.00048828125,
        -3224.7685546875,
        1016.1558837890625
      ],
      "bbox_max": [
        -3898.5,
        -3184.77001953125,
        1079.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1079.800048828125,
      "bbox_min": [
        -3920.00048828125,
        -3224.7685546875,
        1039.786865234375
      ],
      "bbox_max": [
        -3898.5,
        -3184.77001953125,
        1079.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.786865234375,
      "bbox_min": [
        -3901.50048828125,
        -3224.7685546875,
        1039.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3184.77001953125,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1039.786865234375,
      "bbox_min": [
        -3901.50048828125,
        -3224.7685546875,
        1039.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3184.77001953125,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1155.0,
      "bbox_min": [
        -4115.0,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3925.0,
        -2775.0,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9448028206825256,
        -0.32763931155204773
      ],
      "plane_d": -2674.881591796875,
      "bbox_min": [
        -3950.00048828125,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3925.0,
        -3182.2685546875,
        1019.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9448028206825256,
        0.32763931155204773
      ],
      "plane_d": -3338.35107421875,
      "bbox_min": [
        -3950.00048828125,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3940.00048828125,
        -3182.2685546875,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -4115.0,
        -3645.0,
        1005.2000122070312
      ],
      "bbox_max": [
        -3925.0,
        -3184.800048828125,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1155.0,
      "bbox_min": [
        -4115.0,
        -3405.0,
        1110.0
      ],
      "bbox_max": [
        -3925.0,
        -3184.800048828125,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6689647436141968,
        -0.7432941198348999
      ],
      "plane_d": 3102.88134765625,
      "bbox_min": [
        -4115.0,
        -3405.0,
        1110.0
      ],
      "bbox_max": [
        -3925.0,
        -3355.0,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1005.2000122070312,
      "bbox_min": [
        -3972.50048828125,
        -3207.2685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3950.00048828125,
        -3184.800048828125,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460594058036804,
        0.0,
        0.3239934742450714
      ],
      "plane_d": 3430.177978515625,
      "bbox_min": [
        -3972.50048828125,
        -3207.2685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3970.00048828125,
        -3184.800048828125,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1090.0,
      "bbox_min": [
        -3795.494384765625,
        -3645.0,
        1037.0
      ],
      "bbox_max": [
        -3175.0,
        -2775.0,
        1170.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1037.0,
      "bbox_min": [
        -3625.0,
        -3295.0,
        1037.0
      ],
      "bbox_max": [
        -3531.0,
        -3148.0,
        1059.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1057.0,
      "bbox_min": [
        -3625.0,
        -3295.0,
        1037.0
      ],
      "bbox_max": [
        -3531.0,
        -3148.0,
        1059.800048828125
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.9348782896995544,
        0.35496851801872253,
        0.0
      ],
      "plane_d": -2152.73193359375,
      "bbox_min": [
        -3625.0,
        -3295.0,
        1057.0
      ],
      "bbox_max": [
        -3531.0,
        -3199.9580078125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9348782896995544,
        0.35496851801872253,
        0.0
      ],
      "plane_d": 4537.2568359375,
      "bbox_min": [
        -3625.0,
        -3295.0,
        1057.0
      ],
      "bbox_max": [
        -3531.0,
        -3199.9580078125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4117788076400757,
        0.9112839102745056,
        0.0
      ],
      "plane_d": 1526.0416259765625,
      "bbox_min": [
        -3625.0,
        -3295.0,
        1057.0
      ],
      "bbox_max": [
        -3531.0,
        -3199.9580078125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9348791241645813,
        -0.3549664318561554,
        -0.0
      ],
      "plane_d": -4449.37451171875,
      "bbox_min": [
        -3625.0,
        -3295.0,
        1057.0
      ],
      "bbox_max": [
        -3531.0,
        -3199.9580078125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16007116436958313,
        -0.9871054887771606,
        0.0
      ],
      "plane_d": -2613.40185546875,
      "bbox_min": [
        -3625.0,
        -3295.0,
        1057.0
      ],
      "bbox_max": [
        -3544.30517578125,
        -3199.9580078125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9348794221878052,
        -0.3549657464027405,
        0.0
      ],
      "plane_d": 2240.623779296875,
      "bbox_min": [
        -3625.0,
        -3235.0,
        1057.0
      ],
      "bbox_max": [
        -3544.30517578125,
        -3199.9580078125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8923662304878235,
        -0.4513120949268341,
        -0.0
      ],
      "plane_d": -4668.92333984375,
      "bbox_min": [
        -3612.554443359375,
        -3231.0,
        1057.0
      ],
      "bbox_max": [
        -3544.30517578125,
        -3199.9580078125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320478200912476,
        -0.554703950881958,
        0.0
      ],
      "plane_d": 1174.0020751953125,
      "bbox_min": [
        -3561.0,
        -3225.0,
        1057.0
      ],
      "bbox_max": [
        -3544.30517578125,
        -3199.9580078125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6089512705802917,
        0.7932076454162598,
        0.0
      ],
      "plane_d": 4797.318359375,
      "bbox_min": [
        -3608.890869140625,
        -3295.0,
        1057.0
      ],
      "bbox_max": [
        -3586.0,
        -3277.426513671875,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24312946200370789,
        0.5380557775497437,
        0.8070836067199707
      ],
      "plane_d": 47.944091796875,
      "bbox_min": [
        -3625.0,
        -3295.0,
        1037.0
      ],
      "bbox_max": [
        -3531.0,
        -3148.0,
        1057.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1633625626564026,
        0.6636362075805664,
        0.7299997210502625
      ],
      "plane_d": 823.9443359375,
      "bbox_min": [
        -3586.0,
        -3277.426513671875,
        1037.0
      ],
      "bbox_max": [
        -3544.122314453125,
        -3246.626220703125,
        1057.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8708463311195374,
        0.33065593242645264,
        0.36372148990631104
      ],
      "plane_d": -2389.740234375,
      "bbox_min": [
        -3547.109130859375,
        -3277.426513671875,
        1037.0
      ],
      "bbox_max": [
        -3544.122314453125,
        -3246.626220703125,
        1057.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8450129628181458,
        0.16998833417892456,
        0.5070078372955322
      ],
      "plane_d": -2969.73583984375,
      "bbox_min": [
        -3547.109130859375,
        -3255.426513671875,
        1037.0
      ],
      "bbox_max": [
        -3544.122314453125,
        -3246.626220703125,
        1040.7083740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3918008804321289,
        0.5103519558906555,
        0.7655278444290161
      ],
      "plane_d": 2277.44482421875,
      "bbox_min": [
        -3625.0,
        -3295.0,
        1037.0
      ],
      "bbox_max": [
        -3531.0,
        -3148.0,
        1057.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8251940608024597,
        0.313321977853775,
        0.46998295187950134
      ],
      "plane_d": 3508.1533203125,
      "bbox_min": [
        -3625.0,
        -3277.426513671875,
        1037.0
      ],
      "bbox_max": [
        -3531.0,
        -3148.0,
        1057.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8551978468894958,
        -0.5183017253875732,
        0.0
      ],
      "plane_d": 1429.7315673828125,
      "bbox_min": [
        -3625.0,
        -3277.426513671875,
        1037.0
      ],
      "bbox_max": [
        -3531.0,
        -3148.0,
        1057.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8708463311195374,
        0.33065593242645264,
        0.36372148990631104
      ],
      "plane_d": -2389.740234375,
      "bbox_min": [
        -3625.0,
        -3277.426513671875,
        1037.0
      ],
      "bbox_max": [
        -3531.0,
        -3148.0,
        1057.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3544.30517578125,
      "bbox_min": [
        -3561.915771484375,
        -3199.9580078125,
        1037.0
      ],
      "bbox_max": [
        -3544.30517578125,
        -3153.577392578125,
        1057.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.61314857006073,
        -0.7899677157402039,
        -0.0
      ],
      "plane_d": -4674.98046875,
      "bbox_min": [
        -3561.915771484375,
        -3166.9580078125,
        1037.0
      ],
      "bbox_max": [
        -3544.30517578125,
        -3153.577392578125,
        1057.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4190582036972046,
        -0.9079594612121582,
        -0.0
      ],
      "plane_d": -4355.97021484375,
      "bbox_min": [
        -3561.915771484375,
        -3154.0,
        1037.0
      ],
      "bbox_max": [
        -3561.0,
        -3153.577392578125,
        1057.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8570559620857239,
        -0.03192194923758507,
        0.5142335295677185
      ],
      "plane_d": -3673.0771484375,
      "bbox_min": [
        -3625.0,
        -3251.63916015625,
        1037.0
      ],
      "bbox_max": [
        -3531.0,
        -3148.0,
        1057.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8153651356697083,
        -0.3095872402191162,
        0.4892190992832184
      ],
      "plane_d": 1437.079345703125,
      "bbox_min": [
        -3625.0,
        -3251.63916015625,
        1037.0
      ],
      "bbox_max": [
        -3531.0,
        -3148.0,
        1057.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999076128005981,
        -0.013591873459517956,
        0.0
      ],
      "plane_d": 3568.696533203125,
      "bbox_min": [
        -3613.0,
        -3235.0,
        1037.0
      ],
      "bbox_max": [
        -3584.54736328125,
        -3160.063720703125,
        1057.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7528358697891235,
        -0.658208429813385,
        0.0
      ],
      "plane_d": 618.59521484375,
      "bbox_min": [
        -3592.554443359375,
        -3169.221923828125,
        1037.0
      ],
      "bbox_max": [
        -3584.54736328125,
        -3160.063720703125,
        1044.549560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7528358697891235,
        -0.658208429813385,
        0.0
      ],
      "plane_d": 618.59521484375,
      "bbox_min": [
        -3625.0,
        -3251.63916015625,
        1037.0
      ],
      "bbox_max": [
        -3531.0,
        -3148.0,
        1057.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8249697089195251,
        0.2727964520454407,
        0.4949818551540375
      ],
      "plane_d": 3349.81591796875,
      "bbox_min": [
        -3625.0,
        -3251.63916015625,
        1037.0
      ],
      "bbox_max": [
        -3531.0,
        -3148.0,
        1057.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8450129628181458,
        0.16998833417892456,
        0.5070078372955322
      ],
      "plane_d": -2969.73583984375,
      "bbox_min": [
        -3574.0,
        -3251.63916015625,
        1037.0
      ],
      "bbox_max": [
        -3531.0,
        -3148.0,
        1057.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4190582036972046,
        -0.9079594612121582,
        -0.0
      ],
      "plane_d": -4355.97021484375,
      "bbox_min": [
        -3574.0,
        -3153.577392578125,
        1037.0
      ],
      "bbox_max": [
        -3561.915771484375,
        -3148.0,
        1057.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3737.0,
      "bbox_min": [
        -3746.4248046875,
        -3335.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3451.0,
        -3135.0,
        1090.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1072.5999755859375,
      "bbox_min": [
        -3746.4248046875,
        -3240.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3737.0,
        -3196.375244140625,
        1072.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3738.0,
      "bbox_min": [
        -3746.4248046875,
        -3240.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3737.0,
        -3196.375244140625,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3240.800048828125,
      "bbox_min": [
        -3738.0,
        -3240.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3737.0,
        -3224.7685546875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3224.7685546875,
      "bbox_min": [
        -3738.0,
        -3224.7685546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3737.0,
        -3224.7685546875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -4909.30126953125,
      "bbox_min": [
        -3746.4248046875,
        -3240.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3738.0,
        -3196.375244140625,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3240.800048828125,
      "bbox_min": [
        -3746.4248046875,
        -3240.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3738.0,
        -3240.800048828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8862254619598389,
        0.4632542133331299,
        -0.0
      ],
      "plane_d": 4831.29833984375,
      "bbox_min": [
        -3737.0,
        -3335.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3451.0,
        -3135.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8671056032180786,
        -0.49812448024749756,
        0.0
      ],
      "plane_d": 1650.8582763671875,
      "bbox_min": [
        -3737.0,
        -3335.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3451.0,
        -3135.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09053575247526169,
        0.9958932995796204,
        0.0
      ],
      "plane_d": 2993.927001953125,
      "bbox_min": [
        -3737.0,
        -3335.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3451.0,
        -3135.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8923664093017578,
        -0.45131173729896545,
        0.0
      ],
      "plane_d": -4668.9228515625,
      "bbox_min": [
        -3737.0,
        -3335.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3451.0,
        -3135.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503830909729,
        -0.5547001957893372,
        0.0
      ],
      "plane_d": 1174.023193359375,
      "bbox_min": [
        -3598.0,
        -3327.5,
        1059.800048828125
      ],
      "bbox_max": [
        -3451.0,
        -3135.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16007116436958313,
        -0.9871054887771606,
        0.0
      ],
      "plane_d": -2613.40185546875,
      "bbox_min": [
        -3598.0,
        -3231.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3561.0,
        -3225.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9977852702140808,
        0.06651902198791504,
        0.0
      ],
      "plane_d": -3232.49169921875,
      "bbox_min": [
        -3544.30517578125,
        -3327.5,
        1059.800048828125
      ],
      "bbox_max": [
        -3451.0,
        -3135.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.014866143465042114,
        0.9998894929885864,
        -0.0
      ],
      "plane_d": 3287.135009765625,
      "bbox_min": [
        -3544.30517578125,
        -3327.5,
        1059.800048828125
      ],
      "bbox_max": [
        -3451.0,
        -3135.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8778955936431885,
        0.47885215282440186,
        0.0
      ],
      "plane_d": -1480.1318359375,
      "bbox_min": [
        -3537.89892578125,
        -3327.5,
        1059.800048828125
      ],
      "bbox_max": [
        -3456.0,
        -3235.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5010362863540649,
        0.8654263019561768,
        0.0
      ],
      "plane_d": 1109.2943115234375,
      "bbox_min": [
        -3537.89892578125,
        -3327.5,
        1059.800048828125
      ],
      "bbox_max": [
        -3486.0,
        -3235.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.911232590675354,
        -0.4118924140930176,
        0.0
      ],
      "plane_d": 1862.5098876953125,
      "bbox_min": [
        -3537.89892578125,
        -3296.158935546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3500.109619140625,
        -3235.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9196723699569702,
        -0.3926866948604584,
        0.0
      ],
      "plane_d": -4531.1845703125,
      "bbox_min": [
        -3537.89892578125,
        -3279.865966796875,
        1059.800048828125
      ],
      "bbox_max": [
        -3526.5,
        -3235.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.934878408908844,
        0.3549681603908539,
        0.0
      ],
      "plane_d": -2152.73388671875,
      "bbox_min": [
        -3537.89892578125,
        -3253.169677734375,
        1059.800048828125
      ],
      "bbox_max": [
        -3531.0,
        -3235.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3288.2685546875,
      "bbox_min": [
        -3515.890869140625,
        -3296.158935546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3500.109619140625,
        -3280.3779296875,
        1085.65185546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3508.000244140625,
      "bbox_min": [
        -3515.890869140625,
        -3296.158935546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3500.109619140625,
        -3288.2685546875,
        1085.65185546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4082241356372833,
        -0.40828341245651245,
        -0.8164910078048706
      ],
      "plane_d": 967.9013061523438,
      "bbox_min": [
        -3508.000244140625,
        -3296.158935546875,
        1075.81884765625
      ],
      "bbox_max": [
        -3500.109619140625,
        -3288.2685546875,
        1085.65185546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.40822869539260864,
        -0.4082396328449249,
        -0.816510796546936
      ],
      "plane_d": 972.011474609375,
      "bbox_min": [
        -3508.000244140625,
        -3294.5810546875,
        1080.630615234375
      ],
      "bbox_max": [
        -3501.687744140625,
        -3288.2685546875,
        1085.65185546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.40826934576034546,
        -0.4082441031932831,
        -0.8164882063865662
      ],
      "plane_d": -1896.23193359375,
      "bbox_min": [
        -3515.890869140625,
        -3296.158935546875,
        1075.81884765625
      ],
      "bbox_max": [
        -3508.000244140625,
        -3288.2685546875,
        1085.65185546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4082396328449249,
        -0.40822869539260864,
        -0.816510796546936
      ],
      "plane_d": -1892.123779296875,
      "bbox_min": [
        -3514.312744140625,
        -3294.5810546875,
        1080.630615234375
      ],
      "bbox_max": [
        -3508.000244140625,
        -3288.2685546875,
        1085.65185546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3508.000244140625,
      "bbox_min": [
        -3515.890869140625,
        -3288.2685546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3500.109619140625,
        -3280.3779296875,
        1085.65185546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4082728624343872,
        0.40822625160217285,
        -0.8164952397346497
      ],
      "plane_d": 3652.97998046875,
      "bbox_min": [
        -3508.000244140625,
        -3288.2685546875,
        1075.81884765625
      ],
      "bbox_max": [
        -3500.109619140625,
        -3280.3779296875,
        1085.65185546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.40822869539260864,
        -0.4082396328449249,
        0.816510796546936
      ],
      "plane_d": -3656.814453125,
      "bbox_min": [
        -3508.000244140625,
        -3288.2685546875,
        1080.630615234375
      ],
      "bbox_max": [
        -3501.687744140625,
        -3281.9560546875,
        1085.65185546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.40825355052948,
        0.40825355052948,
        -0.8164912462234497
      ],
      "plane_d": 788.6904296875,
      "bbox_min": [
        -3515.890869140625,
        -3288.2685546875,
        1075.81884765625
      ],
      "bbox_max": [
        -3508.000244140625,
        -3280.3779296875,
        1085.65185546875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.40822869539260864,
        0.4082396328449249,
        -0.816510796546936
      ],
      "plane_d": 792.681640625,
      "bbox_min": [
        -3514.312744140625,
        -3288.2685546875,
        1080.630615234375
      ],
      "bbox_max": [
        -3508.000244140625,
        -3281.9560546875,
        1085.65185546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6824833750724792,
        0.7309011220932007,
        -0.0
      ],
      "plane_d": 4757.7822265625,
      "bbox_min": [
        -3544.30517578125,
        -3235.365966796875,
        1059.800048828125
      ],
      "bbox_max": [
        -3451.0,
        -3135.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1080.0,
      "bbox_min": [
        -3544.30517578125,
        -3235.365966796875,
        1059.800048828125
      ],
      "bbox_max": [
        -3506.38525390625,
        -3199.9580078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9348791241645813,
        -0.3549664318561554,
        0.0
      ],
      "plane_d": -4449.37451171875,
      "bbox_min": [
        -3544.30517578125,
        -3235.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3531.0,
        -3199.9580078125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1069.9998779296875,
      "bbox_min": [
        -3544.30517578125,
        -3235.365966796875,
        1059.800048828125
      ],
      "bbox_max": [
        -3451.0,
        -3135.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9191450476646423,
        -0.39391928911209106,
        0.0
      ],
      "plane_d": -4420.693359375,
      "bbox_min": [
        -3534.09814453125,
        -3235.365966796875,
        1059.800048828125
      ],
      "bbox_max": [
        -3451.0,
        -3135.0,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3135.0,
      "bbox_min": [
        -3534.09814453125,
        -3235.365966796875,
        1059.800048828125
      ],
      "bbox_max": [
        -3466.0,
        -3135.0,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9970060586929321,
        0.07732435315847397,
        -0.0
      ],
      "plane_d": 3746.06005859375,
      "bbox_min": [
        -3534.09814453125,
        -3235.365966796875,
        1059.800048828125
      ],
      "bbox_max": [
        -3506.38525390625,
        -3184.6474609375,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5654605627059937,
        0.8247753381729126,
        -0.0
      ],
      "plane_d": 4625.01171875,
      "bbox_min": [
        -3534.09814453125,
        -3201.865966796875,
        1059.800048828125
      ],
      "bbox_max": [
        -3508.9833984375,
        -3184.6474609375,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9191450476646423,
        -0.39391928911209106,
        0.0
      ],
      "plane_d": -4420.693359375,
      "bbox_min": [
        -3501.0,
        -3170.0,
        1070.0
      ],
      "bbox_max": [
        -3451.0,
        -3135.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3135.0,
      "bbox_min": [
        -3501.0,
        -3135.0,
        1070.0
      ],
      "bbox_max": [
        -3466.0,
        -3135.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11154443770647049,
        0.9937595129013062,
        -0.0
      ],
      "plane_d": 3717.53271484375,
      "bbox_min": [
        -3737.0,
        -3335.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3612.554443359375,
        -3144.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9348794221878052,
        -0.3549657464027405,
        0.0
      ],
      "plane_d": 2240.62353515625,
      "bbox_min": [
        -3737.0,
        -3324.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3612.554443359375,
        -3144.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 275.771728515625,
      "bbox_min": [
        -3737.0,
        -3324.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3612.554443359375,
        -3144.0,
        1090.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -280.77197265625,
      "bbox_min": [
        -3737.0,
        -3324.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3612.554443359375,
        -3144.0,
        1090.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1074.9998779296875,
      "bbox_min": [
        -3716.427490234375,
        -3324.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3620.671630859375,
        -3223.60009765625,
        1075.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 4912.3212890625,
      "bbox_min": [
        -3672.0712890625,
        -3278.53564453125,
        1059.800048828125
      ],
      "bbox_max": [
        -3668.53564453125,
        -3275.0,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9271170496940613,
        0.3747720420360565,
        0.0
      ],
      "plane_d": -2153.0146484375,
      "bbox_min": [
        -3737.0,
        -3283.158935546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3612.554443359375,
        -3144.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1074.9998779296875,
      "bbox_min": [
        -3628.53564453125,
        -3231.46435546875,
        1075.0
      ],
      "bbox_max": [
        -3612.554443359375,
        -3197.64990234375,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.500004231929779,
        0.8660230040550232,
        -0.0
      ],
      "plane_d": 4675.123046875,
      "bbox_min": [
        -3737.0,
        -3250.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3732.669921875,
        -3214.7685546875,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.500004231929779,
        -0.8660230040550232,
        0.0
      ],
      "plane_d": -946.7518310546875,
      "bbox_min": [
        -3737.0,
        -3250.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3732.669921875,
        -3240.800048828125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1080.0,
      "bbox_min": [
        -3737.0,
        -3250.800048828125,
        1080.0
      ],
      "bbox_max": [
        -3732.669921875,
        -3240.800048828125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.500004231929779,
        0.8660230040550232,
        0.0
      ],
      "plane_d": 4652.5791015625,
      "bbox_min": [
        -3737.0,
        -3224.7685546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3732.669921875,
        -3214.7685546875,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.500004231929779,
        -0.8660230040550232,
        0.0
      ],
      "plane_d": -924.207763671875,
      "bbox_min": [
        -3737.0,
        -3224.7685546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3732.669921875,
        -3214.7685546875,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1080.0,
      "bbox_min": [
        -3737.0,
        -3224.7685546875,
        1080.0
      ],
      "bbox_max": [
        -3732.669921875,
        -3214.7685546875,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3210.238037109375,
      "bbox_min": [
        -3715.890869140625,
        -3283.158935546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3642.0,
        -3144.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3220.238037109375,
      "bbox_min": [
        -3715.890869140625,
        -3283.158935546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3652.0,
        -3210.238037109375,
        1085.65185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1075.0,
      "bbox_min": [
        -3700.0,
        -3220.238037109375,
        1059.800048828125
      ],
      "bbox_max": [
        -3652.0,
        -3210.238037109375,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3700.0,
      "bbox_min": [
        -3700.0,
        -3220.238037109375,
        1059.800048828125
      ],
      "bbox_max": [
        -3652.0,
        -3210.238037109375,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3652.0,
      "bbox_min": [
        -3652.0,
        -3220.238037109375,
        1059.800048828125
      ],
      "bbox_max": [
        -3652.0,
        -3210.238037109375,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3275.2685546875,
      "bbox_min": [
        -3715.890869140625,
        -3283.158935546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3700.109619140625,
        -3267.3779296875,
        1085.65185546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3708.000244140625,
      "bbox_min": [
        -3715.890869140625,
        -3283.158935546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3700.109619140625,
        -3275.2685546875,
        1085.65185546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4082241356372833,
        -0.40828341245651245,
        -0.8164910078048706
      ],
      "plane_d": 1054.853759765625,
      "bbox_min": [
        -3708.000244140625,
        -3283.158935546875,
        1075.81884765625
      ],
      "bbox_max": [
        -3700.109619140625,
        -3275.2685546875,
        1085.65185546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.40822869539260864,
        -0.4082396328449249,
        -0.816510796546936
      ],
      "plane_d": 1058.9642333984375,
      "bbox_min": [
        -3708.000244140625,
        -3281.5810546875,
        1080.630615234375
      ],
      "bbox_max": [
        -3701.687744140625,
        -3275.2685546875,
        1085.65185546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.40826934576034546,
        -0.4082441031932831,
        -0.8164882063865662
      ],
      "plane_d": -1972.57861328125,
      "bbox_min": [
        -3715.890869140625,
        -3283.158935546875,
        1075.81884765625
      ],
      "bbox_max": [
        -3708.000244140625,
        -3275.2685546875,
        1085.65185546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4082396328449249,
        -0.40822869539260864,
        -0.816510796546936
      ],
      "plane_d": -1968.4647216796875,
      "bbox_min": [
        -3714.312744140625,
        -3281.5810546875,
        1080.630615234375
      ],
      "bbox_max": [
        -3708.000244140625,
        -3275.2685546875,
        1085.65185546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3708.000244140625,
      "bbox_min": [
        -3715.890869140625,
        -3275.2685546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3700.109619140625,
        -3267.3779296875,
        1085.65185546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4082728624343872,
        0.40822625160217285,
        -0.8164952397346497
      ],
      "plane_d": 3729.32763671875,
      "bbox_min": [
        -3708.000244140625,
        -3275.2685546875,
        1075.81884765625
      ],
      "bbox_max": [
        -3700.109619140625,
        -3267.3779296875,
        1085.65185546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.40822869539260864,
        -0.4082396328449249,
        0.816510796546936
      ],
      "plane_d": -3733.153076171875,
      "bbox_min": [
        -3708.000244140625,
        -3275.2685546875,
        1080.630615234375
      ],
      "bbox_max": [
        -3701.687744140625,
        -3268.9560546875,
        1085.65185546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.40825355052948,
        0.40825355052948,
        -0.8164912462234497
      ],
      "plane_d": 701.7322998046875,
      "bbox_min": [
        -3715.890869140625,
        -3275.2685546875,
        1075.81884765625
      ],
      "bbox_max": [
        -3708.000244140625,
        -3267.3779296875,
        1085.65185546875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.40822869539260864,
        0.4082396328449249,
        -0.816510796546936
      ],
      "plane_d": 705.728759765625,
      "bbox_min": [
        -3714.312744140625,
        -3275.2685546875,
        1080.630615234375
      ],
      "bbox_max": [
        -3708.000244140625,
        -3268.9560546875,
        1085.65185546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1072.0,
      "bbox_min": [
        -3710.0,
        -3210.238037109375,
        1059.800048828125
      ],
      "bbox_max": [
        -3642.0,
        -3144.0,
        1090.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        -3710.0,
        -3210.238037109375,
        1059.800048828125
      ],
      "bbox_max": [
        -3642.0,
        -3144.0,
        1072.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.3996100127696991,
        -0.9166852831840515,
        -0.0
      ],
      "plane_d": -4384.0087890625,
      "bbox_min": [
        -3710.0,
        -3210.238037109375,
        1070.0
      ],
      "bbox_max": [
        -3642.0,
        -3144.0,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3996100127696991,
        -0.9166852831840515,
        0.0
      ],
      "plane_d": -1446.076171875,
      "bbox_min": [
        -3710.0,
        -3181.725341796875,
        1070.0
      ],
      "bbox_max": [
        -3642.0,
        -3144.0,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3710.0,
      "bbox_min": [
        -3710.0,
        -3165.16015625,
        1070.0
      ],
      "bbox_max": [
        -3642.0,
        -3144.0,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3642.0,
      "bbox_min": [
        -3710.0,
        -3165.16015625,
        1070.0
      ],
      "bbox_max": [
        -3642.0,
        -3144.0,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9321846961975098,
        -0.36198320984840393,
        0.0
      ],
      "plane_d": -4561.05712890625,
      "bbox_min": [
        -3710.0,
        -3160.0,
        1070.0
      ],
      "bbox_max": [
        -3642.0,
        -3144.0,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321846961975098,
        -0.36198320984840393,
        0.0
      ],
      "plane_d": 2256.94140625,
      "bbox_min": [
        -3667.606689453125,
        -3160.0,
        1070.0
      ],
      "bbox_max": [
        -3642.0,
        -3144.0,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40413516759872437,
        -0.9146992564201355,
        0.0
      ],
      "plane_d": -1412.52734375,
      "bbox_min": [
        -3667.606689453125,
        -3160.0,
        1070.0
      ],
      "bbox_max": [
        -3646.393310546875,
        -3155.313720703125,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40413516759872437,
        -0.9146992564201355,
        0.0
      ],
      "plane_d": -4368.3720703125,
      "bbox_min": [
        -3667.606689453125,
        -3160.0,
        1070.0
      ],
      "bbox_max": [
        -3657.0,
        -3155.313720703125,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321846961975098,
        -0.36198320984840393,
        0.0
      ],
      "plane_d": 2292.36474609375,
      "bbox_min": [
        -3710.0,
        -3160.0,
        1070.0
      ],
      "bbox_max": [
        -3672.0,
        -3144.0,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9321846961975098,
        -0.36198320984840393,
        -0.0
      ],
      "plane_d": -4596.48046875,
      "bbox_min": [
        -3710.0,
        -3160.0,
        1070.0
      ],
      "bbox_max": [
        -3684.393310546875,
        -3144.0,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40413516759872437,
        -0.9146992564201355,
        -0.0
      ],
      "plane_d": -4383.72900390625,
      "bbox_min": [
        -3705.606689453125,
        -3160.0,
        1070.0
      ],
      "bbox_max": [
        -3684.393310546875,
        -3155.313720703125,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40413516759872437,
        -0.9146992564201355,
        0.0
      ],
      "plane_d": -1397.1702880859375,
      "bbox_min": [
        -3695.0,
        -3160.0,
        1070.0
      ],
      "bbox_max": [
        -3684.393310546875,
        -3155.313720703125,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3144.0,
      "bbox_min": [
        -3680.0,
        -3144.0,
        1070.0
      ],
      "bbox_max": [
        -3672.0,
        -3144.0,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3672.0,
      "bbox_min": [
        -3672.0,
        -3181.725341796875,
        1070.0
      ],
      "bbox_max": [
        -3672.0,
        -3178.238037109375,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3680.0,
      "bbox_min": [
        -3683.27880859375,
        -3210.238037109375,
        1070.0
      ],
      "bbox_max": [
        -3668.72119140625,
        -3178.238037109375,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3672.0,
      "bbox_min": [
        -3672.0,
        -3210.238037109375,
        1070.0
      ],
      "bbox_max": [
        -3668.72119140625,
        -3181.725341796875,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5207577347755432,
        0.0,
        0.8537046313285828
      ],
      "plane_d": 997.051025390625,
      "bbox_min": [
        -3672.0,
        -3210.238037109375,
        1070.0
      ],
      "bbox_max": [
        -3668.72119140625,
        -3200.238037109375,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3200.23779296875,
      "bbox_min": [
        -3672.0,
        -3200.238037109375,
        1070.0
      ],
      "bbox_max": [
        -3668.72119140625,
        -3200.238037109375,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5207577347755432,
        0.0,
        0.8537046313285828
      ],
      "plane_d": -2831.559814453125,
      "bbox_min": [
        -3683.27880859375,
        -3210.238037109375,
        1070.0
      ],
      "bbox_max": [
        -3680.0,
        -3200.238037109375,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3200.238037109375,
      "bbox_min": [
        -3683.27880859375,
        -3200.238037109375,
        1070.0
      ],
      "bbox_max": [
        -3680.0,
        -3200.238037109375,
        1072.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3200.238037109375,
      "bbox_min": [
        -3710.0,
        -3210.238037109375,
        1059.800048828125
      ],
      "bbox_max": [
        -3642.0,
        -3144.0,
        1070.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5219982266426086,
        0.0,
        -0.8529465794563293
      ],
      "plane_d": 2833.6064453125,
      "bbox_min": [
        -3696.666748046875,
        -3210.238037109375,
        1059.800048828125
      ],
      "bbox_max": [
        -3655.333251953125,
        -3200.238037109375,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5219982266426086,
        0.0,
        -0.8529465794563293
      ],
      "plane_d": -1004.1246337890625,
      "bbox_min": [
        -3672.0,
        -3210.238037109375,
        1059.800048828125
      ],
      "bbox_max": [
        -3655.333251953125,
        -3200.238037109375,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9321846961975098,
        -0.36198320984840393,
        0.0
      ],
      "plane_d": -4561.05712890625,
      "bbox_min": [
        -3710.0,
        -3160.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3642.0,
        -3144.0,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321846961975098,
        -0.36198320984840393,
        0.0
      ],
      "plane_d": 2256.94140625,
      "bbox_min": [
        -3667.606689453125,
        -3160.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3642.0,
        -3144.0,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40413516759872437,
        -0.9146992564201355,
        0.0
      ],
      "plane_d": -1412.52734375,
      "bbox_min": [
        -3667.606689453125,
        -3160.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3646.393310546875,
        -3155.313720703125,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40413516759872437,
        -0.9146992564201355,
        0.0
      ],
      "plane_d": -4368.3720703125,
      "bbox_min": [
        -3667.606689453125,
        -3160.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3657.0,
        -3155.313720703125,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321846961975098,
        -0.36198320984840393,
        0.0
      ],
      "plane_d": 2292.36474609375,
      "bbox_min": [
        -3710.0,
        -3160.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3672.0,
        -3144.0,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9321846961975098,
        -0.36198320984840393,
        -0.0
      ],
      "plane_d": -4596.48046875,
      "bbox_min": [
        -3710.0,
        -3160.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3684.393310546875,
        -3144.0,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40413516759872437,
        -0.9146992564201355,
        -0.0
      ],
      "plane_d": -4383.72900390625,
      "bbox_min": [
        -3705.606689453125,
        -3160.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3684.393310546875,
        -3155.313720703125,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40413516759872437,
        -0.9146992564201355,
        0.0
      ],
      "plane_d": -1397.1702880859375,
      "bbox_min": [
        -3695.0,
        -3160.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3684.393310546875,
        -3155.313720703125,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3144.0,
      "bbox_min": [
        -3680.0,
        -3144.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3672.0,
        -3144.0,
        1070.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9321846961975098,
        -0.36198320984840393,
        0.0
      ],
      "plane_d": -4561.05712890625,
      "bbox_min": [
        -3710.0,
        -3160.0,
        1072.0
      ],
      "bbox_max": [
        -3642.0,
        -3144.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321846961975098,
        -0.36198320984840393,
        0.0
      ],
      "plane_d": 2256.94140625,
      "bbox_min": [
        -3667.606689453125,
        -3160.0,
        1072.0
      ],
      "bbox_max": [
        -3642.0,
        -3144.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40413516759872437,
        -0.9146992564201355,
        0.0
      ],
      "plane_d": -1412.52734375,
      "bbox_min": [
        -3667.606689453125,
        -3160.0,
        1072.0
      ],
      "bbox_max": [
        -3646.393310546875,
        -3155.313720703125,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40413516759872437,
        -0.9146992564201355,
        0.0
      ],
      "plane_d": -4368.3720703125,
      "bbox_min": [
        -3667.606689453125,
        -3160.0,
        1072.0
      ],
      "bbox_max": [
        -3657.0,
        -3155.313720703125,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321846961975098,
        -0.36198320984840393,
        0.0
      ],
      "plane_d": 2292.36474609375,
      "bbox_min": [
        -3710.0,
        -3160.0,
        1072.0
      ],
      "bbox_max": [
        -3672.0,
        -3144.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9321846961975098,
        -0.36198320984840393,
        -0.0
      ],
      "plane_d": -4596.48046875,
      "bbox_min": [
        -3710.0,
        -3160.0,
        1072.0
      ],
      "bbox_max": [
        -3684.393310546875,
        -3144.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40413516759872437,
        -0.9146992564201355,
        -0.0
      ],
      "plane_d": -4383.72900390625,
      "bbox_min": [
        -3705.606689453125,
        -3160.0,
        1072.0
      ],
      "bbox_max": [
        -3684.393310546875,
        -3155.313720703125,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40413516759872437,
        -0.9146992564201355,
        0.0
      ],
      "plane_d": -1397.1702880859375,
      "bbox_min": [
        -3695.0,
        -3160.0,
        1072.0
      ],
      "bbox_max": [
        -3684.393310546875,
        -3155.313720703125,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3144.0,
      "bbox_min": [
        -3680.0,
        -3144.0,
        1072.0
      ],
      "bbox_max": [
        -3672.0,
        -3144.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1155.0,
      "bbox_min": [
        -3795.494384765625,
        -3645.0,
        1090.0
      ],
      "bbox_max": [
        -3175.0,
        -2775.0,
        1170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09458895772695541,
        0.842706561088562,
        0.5299986600875854
      ],
      "plane_d": 2574.761474609375,
      "bbox_min": [
        -3787.0,
        -3385.25439453125,
        1155.0
      ],
      "bbox_max": [
        -3400.311767578125,
        -3085.0,
        1170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8479982614517212,
        0.5299989581108093
      ],
      "plane_d": -3243.80517578125,
      "bbox_min": [
        -3787.0,
        -3385.25439453125,
        1155.0
      ],
      "bbox_max": [
        -3400.311767578125,
        -3085.0,
        1170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": -3236.173828125,
      "bbox_min": [
        -3533.759033203125,
        -3103.374755859375,
        1155.0
      ],
      "bbox_max": [
        -3429.173095703125,
        -3085.0,
        1170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7055787444114685,
        -0.47038400173187256,
        0.5299976468086243
      ],
      "plane_d": 417.880126953125,
      "bbox_min": [
        -3533.759033203125,
        -3103.374755859375,
        1155.0
      ],
      "bbox_max": [
        -3429.173095703125,
        -3085.0,
        1170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8479983806610107,
        -0.0,
        0.5299989581108093
      ],
      "plane_d": 2591.27099609375,
      "bbox_min": [
        -3787.0,
        -3385.25439453125,
        1155.0
      ],
      "bbox_max": [
        -3400.311767578125,
        -3093.999755859375,
        1170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7055787444114685,
        -0.47038400173187256,
        0.5299976468086243
      ],
      "plane_d": 417.880126953125,
      "bbox_min": [
        -3787.0,
        -3385.25439453125,
        1155.0
      ],
      "bbox_max": [
        -3400.311767578125,
        -3093.999755859375,
        1170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7515174150466919,
        0.39283910393714905,
        0.5299990773200989
      ],
      "plane_d": 3519.23388671875,
      "bbox_min": [
        -3787.0,
        -3370.72265625,
        1155.0
      ],
      "bbox_max": [
        -3584.98046875,
        -3094.0,
        1170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8615344166755676,
        -0.20990799367427826,
        0.46227380633354187
      ],
      "plane_d": -4301.53759765625,
      "bbox_min": [
        -3617.02099609375,
        -3188.858154296875,
        1155.0
      ],
      "bbox_max": [
        -3584.98046875,
        -3094.0,
        1170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8352459669113159,
        -0.42242324352264404,
        0.35202649235725403
      ],
      "plane_d": -4753.7734375,
      "bbox_min": [
        -3600.16796875,
        -3188.858154296875,
        1155.0
      ],
      "bbox_max": [
        -3584.98046875,
        -3172.545654296875,
        1170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1357402354478836,
        -0.8370640873908997,
        0.5299983024597168
      ],
      "plane_d": -2793.858642578125,
      "bbox_min": [
        -3591.91796875,
        -3188.858154296875,
        1155.0
      ],
      "bbox_max": [
        -3584.98046875,
        -3179.133056640625,
        1170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07677337527275085,
        0.8445155024528503,
        0.5299994349479675
      ],
      "plane_d": 1961.1470947265625,
      "bbox_min": [
        -3616.530517578125,
        -3385.25439453125,
        1155.0
      ],
      "bbox_max": [
        -3400.311767578125,
        -3093.999755859375,
        1170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.84611976146698,
        0.05640798062086105,
        0.5299997329711914
      ],
      "plane_d": -3318.845703125,
      "bbox_min": [
        -3520.8994140625,
        -3376.29638671875,
        1155.0
      ],
      "bbox_max": [
        -3400.311767578125,
        -3093.999755859375,
        1170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7444531917572021,
        0.40606623888015747,
        0.5299997329711914
      ],
      "plane_d": -1832.8450927734375,
      "bbox_min": [
        -3520.8994140625,
        -3376.29638671875,
        1155.0
      ],
      "bbox_max": [
        -3400.311767578125,
        -3093.999755859375,
        1170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4248773753643036,
        0.7338800430297852,
        0.5299993753433228
      ],
      "plane_d": 362.9822998046875,
      "bbox_min": [
        -3520.8994140625,
        -3376.29638671875,
        1155.0
      ],
      "bbox_max": [
        -3400.311767578125,
        -3093.999755859375,
        1170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7794328927993774,
        -0.3340444266796112,
        0.5299988985061646
      ],
      "plane_d": -4326.4423828125,
      "bbox_min": [
        -3435.35498046875,
        -3162.966064453125,
        1155.0
      ],
      "bbox_max": [
        -3400.311767578125,
        -3093.999755859375,
        1170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -3795.494384765625,
        -3645.0,
        1090.0
      ],
      "bbox_max": [
        -3175.0,
        -3094.375,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6689647436141968,
        -0.7432941198348999
      ],
      "plane_d": 3102.88134765625,
      "bbox_min": [
        -3795.494384765625,
        -3405.0,
        1110.0
      ],
      "bbox_max": [
        -3175.0,
        -3094.375,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09458895772695541,
        0.842706561088562,
        0.5299986600875854
      ],
      "plane_d": 2574.761474609375,
      "bbox_min": [
        -3743.635986328125,
        -3375.831787109375,
        1143.0228271484375
      ],
      "bbox_max": [
        -3499.91796875,
        -3354.999755859375,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07677337527275085,
        0.8445155024528503,
        0.5299994349479675
      ],
      "plane_d": 1961.1470947265625,
      "bbox_min": [
        -3743.635986328125,
        -3375.831787109375,
        1143.0228271484375
      ],
      "bbox_max": [
        -3499.91796875,
        -3354.999755859375,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4248773753643036,
        0.7338800430297852,
        0.5299993753433228
      ],
      "plane_d": 362.9822998046875,
      "bbox_min": [
        -3743.635986328125,
        -3367.14697265625,
        1147.942138671875
      ],
      "bbox_max": [
        -3499.91796875,
        -3354.999755859375,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7515174150466919,
        0.39283910393714905,
        0.5299990773200989
      ],
      "plane_d": 3519.23388671875,
      "bbox_min": [
        -3743.635986328125,
        -3361.962158203125,
        1150.892822265625
      ],
      "bbox_max": [
        -3738.35400390625,
        -3355.0,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7055787444114685,
        -0.47038400173187256,
        0.5299976468086243
      ],
      "plane_d": 417.880126953125,
      "bbox_min": [
        -3777.625,
        -3368.307861328125,
        1110.0
      ],
      "bbox_max": [
        -3409.81591796875,
        -3094.375,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8479983806610107,
        -0.0,
        0.5299989581108093
      ],
      "plane_d": 2591.27099609375,
      "bbox_min": [
        -3777.625,
        -3362.569091796875,
        1110.0
      ],
      "bbox_max": [
        -3568.378662109375,
        -3103.375,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8479982614517212,
        0.5299989581108093
      ],
      "plane_d": -3243.80517578125,
      "bbox_min": [
        -3777.625,
        -3362.569091796875,
        1110.0
      ],
      "bbox_max": [
        -3568.378662109375,
        -3103.375,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.735303521156311,
        -0.4224090576171875,
        0.529999315738678
      ],
      "plane_d": 822.22265625,
      "bbox_min": [
        -3777.625,
        -3362.569091796875,
        1110.0
      ],
      "bbox_max": [
        -3568.378662109375,
        -3103.375,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7515174150466919,
        0.39283910393714905,
        0.5299990773200989
      ],
      "plane_d": 3519.23388671875,
      "bbox_min": [
        -3777.625,
        -3362.569091796875,
        1110.0
      ],
      "bbox_max": [
        -3568.378662109375,
        -3103.375,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8615344166755676,
        -0.20990799367427826,
        0.46227380633354187
      ],
      "plane_d": -4301.53759765625,
      "bbox_min": [
        -3634.314208984375,
        -3218.033203125,
        1110.0
      ],
      "bbox_max": [
        -3568.378662109375,
        -3103.375,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8352459669113159,
        -0.42242324352264404,
        0.35202649235725403
      ],
      "plane_d": -4753.7734375,
      "bbox_min": [
        -3629.128662109375,
        -3218.033203125,
        1110.0
      ],
      "bbox_max": [
        -3568.378662109375,
        -3152.783203125,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1357402354478836,
        -0.8370640873908997,
        0.5299983024597168
      ],
      "plane_d": -2793.858642578125,
      "bbox_min": [
        -3596.128662109375,
        -3218.033203125,
        1110.0
      ],
      "bbox_max": [
        -3568.378662109375,
        -3187.733154296875,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.84611976146698,
        0.05640798062086105,
        0.5299997329711914
      ],
      "plane_d": -3318.845703125,
      "bbox_min": [
        -3696.42041015625,
        -3368.307861328125,
        1110.0
      ],
      "bbox_max": [
        -3409.81591796875,
        -3094.375,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07677337527275085,
        0.8445155024528503,
        0.5299994349479675
      ],
      "plane_d": 1961.1470947265625,
      "bbox_min": [
        -3696.42041015625,
        -3368.307861328125,
        1110.0
      ],
      "bbox_max": [
        -3409.81591796875,
        -3094.375,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7444531917572021,
        0.40606623888015747,
        0.5299997329711914
      ],
      "plane_d": -1832.8450927734375,
      "bbox_min": [
        -3696.42041015625,
        -3368.307861328125,
        1110.0
      ],
      "bbox_max": [
        -3409.81591796875,
        -3094.375,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": -3236.173828125,
      "bbox_min": [
        -3696.42041015625,
        -3368.307861328125,
        1110.0
      ],
      "bbox_max": [
        -3409.81591796875,
        -3094.375,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7794328927993774,
        -0.3340444266796112,
        0.5299988985061646
      ],
      "plane_d": -4326.4423828125,
      "bbox_min": [
        -3696.42041015625,
        -3368.307861328125,
        1110.0
      ],
      "bbox_max": [
        -3409.81591796875,
        -3094.375,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09458895772695541,
        0.842706561088562,
        0.5299986600875854
      ],
      "plane_d": 2574.761474609375,
      "bbox_min": [
        -3696.42041015625,
        -3368.307861328125,
        1110.0
      ],
      "bbox_max": [
        -3455.7890625,
        -3309.06201171875,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4248773753643036,
        0.7338800430297852,
        0.5299993753433228
      ],
      "plane_d": 362.9822998046875,
      "bbox_min": [
        -3529.622802734375,
        -3362.842041015625,
        1110.0
      ],
      "bbox_max": [
        -3455.7890625,
        -3309.06201171875,
        1155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7055787444114685,
        -0.47038400173187256,
        0.5299976468086243
      ],
      "plane_d": 417.880126953125,
      "bbox_min": [
        -3749.5,
        -3347.563720703125,
        1090.0
      ],
      "bbox_max": [
        -3438.327880859375,
        -3122.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8479983806610107,
        -0.0,
        0.5299989581108093
      ],
      "plane_d": 2591.27099609375,
      "bbox_min": [
        -3749.5,
        -3343.219482421875,
        1090.0
      ],
      "bbox_max": [
        -3561.0,
        -3131.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8352459669113159,
        -0.42242324352264404,
        0.35202649235725403
      ],
      "plane_d": -4753.7734375,
      "bbox_min": [
        -3749.5,
        -3343.219482421875,
        1090.0
      ],
      "bbox_max": [
        -3561.0,
        -3131.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1357402354478836,
        -0.8370640873908997,
        0.5299983024597168
      ],
      "plane_d": -2793.858642578125,
      "bbox_min": [
        -3642.0,
        -3231.0,
        1090.0
      ],
      "bbox_max": [
        -3561.0,
        -3131.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8615344166755676,
        -0.20990799367427826,
        0.46227380633354187
      ],
      "plane_d": -4301.53759765625,
      "bbox_min": [
        -3642.0,
        -3152.783203125,
        1090.0
      ],
      "bbox_max": [
        -3629.128662109375,
        -3131.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8479982614517212,
        0.5299989581108093
      ],
      "plane_d": -3243.80517578125,
      "bbox_min": [
        -3642.0,
        -3144.0,
        1090.0
      ],
      "bbox_max": [
        -3634.314208984375,
        -3131.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09458895772695541,
        0.842706561088562,
        0.5299986600875854
      ],
      "plane_d": 2574.761474609375,
      "bbox_min": [
        -3749.5,
        -3343.219482421875,
        1090.0
      ],
      "bbox_max": [
        -3633.056640625,
        -3131.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.735303521156311,
        -0.4224090576171875,
        0.529999315738678
      ],
      "plane_d": 822.22265625,
      "bbox_min": [
        -3749.5,
        -3335.6806640625,
        1090.0
      ],
      "bbox_max": [
        -3710.0,
        -3131.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7515174150466919,
        0.39283910393714905,
        0.5299990773200989
      ],
      "plane_d": 3519.23388671875,
      "bbox_min": [
        -3749.5,
        -3335.6806640625,
        1090.0
      ],
      "bbox_max": [
        -3714.0,
        -3280.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07677337527275085,
        0.8445155024528503,
        0.5299994349479675
      ],
      "plane_d": 1961.1470947265625,
      "bbox_min": [
        -3654.835693359375,
        -3347.563720703125,
        1090.0
      ],
      "bbox_max": [
        -3438.327880859375,
        -3122.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.84611976146698,
        0.05640798062086105,
        0.5299997329711914
      ],
      "plane_d": -3318.845703125,
      "bbox_min": [
        -3654.835693359375,
        -3347.563720703125,
        1090.0
      ],
      "bbox_max": [
        -3438.327880859375,
        -3122.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7444531917572021,
        0.40606623888015747,
        0.5299997329711914
      ],
      "plane_d": -1832.8450927734375,
      "bbox_min": [
        -3654.835693359375,
        -3347.563720703125,
        1090.0
      ],
      "bbox_max": [
        -3438.327880859375,
        -3122.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4248773753643036,
        0.7338800430297852,
        0.5299993753433228
      ],
      "plane_d": 362.9822998046875,
      "bbox_min": [
        -3654.835693359375,
        -3347.563720703125,
        1090.0
      ],
      "bbox_max": [
        -3438.327880859375,
        -3122.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7794328927993774,
        -0.3340444266796112,
        0.5299988985061646
      ],
      "plane_d": -4326.4423828125,
      "bbox_min": [
        -3654.835693359375,
        -3347.563720703125,
        1090.0
      ],
      "bbox_max": [
        -3438.327880859375,
        -3122.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": -3236.173828125,
      "bbox_min": [
        -3654.835693359375,
        -3347.563720703125,
        1090.0
      ],
      "bbox_max": [
        -3457.757568359375,
        -3122.5,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09458895772695541,
        0.842706561088562,
        0.5299986600875854
      ],
      "plane_d": 2574.761474609375,
      "bbox_min": [
        -3654.835693359375,
        -3347.563720703125,
        1090.0
      ],
      "bbox_max": [
        -3616.0,
        -3333.08544921875,
        1110.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}